﻿/**
 * German locale messages
 * Mirrors the structure of the English source of truth
 */

import { brand } from '../config/brand';

export default {
  // Wetter-Kontrollen + Dialog (CurrentWeather, WeatherModal, WeatherForecast)
  weather: {
    title: 'Aktuelles Wetter',
    refresh: 'Wetter aktualisieren',
    updated: 'Aktualisiert',
    justNow: 'gerade eben',
    feelsLike: 'Gefühlt',
    humidity: 'Luftfeuchtigkeit',
    wind: 'Wind',
    pressure: 'Luftdruck',
    clouds: 'Wolken',
    visibility: 'Sichtweite',
    sunrise: 'Sonnenaufgang',
    sunset: 'Sonnenuntergang',
    hourlyForecast: 'Stündliche Vorhersage',
    dailyForecast: 'Tagesvorhersage',
    forecastTitle: 'Wettervorhersage',
    hourly: 'Stündlich',
    daily: 'Täglich',
    today: 'Heute',
    tomorrow: 'Morgen',
    unavailable: 'Wetterdaten sind noch nicht verfügbar.',
    forecastUnavailable: 'Vorhersage nicht verfügbar.',
    rainPercent: '{count}% Regen',
    noRain: 'Kein Regen',
    configureInSettings: 'Wetter in den Einstellungen konfigurieren',
    loadFailed: 'Wetterdaten konnten nicht geladen werden',
    alertsTitle: 'Wetterwarnungen',
    now: 'Jetzt',
    scrub: 'Durch die Vorhersage fahren',
    sun: 'Sonne',
    moon: 'Mond',
    moonrise: 'Mondaufgang',
    moonset: 'Monduntergang',
    illumination: 'beleuchtet',
    details: 'Details',
  },
  // Add-Raum-Assistent (AddRoomModal) - statische UI-Texte
  roomWizard: {
    addRooms: 'Räume hinzufügen',
    buildingType: 'Gebäudetyp',
    selectDefaults: 'Standardräume für {type} auswählen',
    selectCommonRooms: 'Gängige Räume auswählen',
    alreadyExists: 'Bereits vorhanden',
    floor: 'Etage {number}',
    addCustomRoom: 'Benutzerdefinierten Raum hinzufügen',
    roomName: 'Raumname',
    roomNamePlaceholder: 'z. B. Gästezimmer, Weinkeller',
    floorNumber: 'Etagennummer',
    floorNumberPlaceholder: '0, 1, 2...',
    addCustomRoomButton: 'Benutzerdefinierten Raum zur Auswahl hinzufügen',
    areaAssignment: 'Bereichszuordnung (optional)',
    assignToArea: 'Bereich zuweisen',
    noArea: 'Kein Bereich',
    areaHelp: 'Alle ausgewählten Räume werden diesem Bereich zugewiesen',
    selectedRooms: 'Ausgewählte Räume ({count})',
    clearAll: 'Alle löschen',
    cancel: 'Abbrechen',
    creating: 'Wird erstellt...',
    createOne: '{count} Raum erstellen',
    createMany: '{count} Räume erstellen',
    searchIcons: 'Symbole suchen',
  },
  // Add-Raum-Assistent - Gebäudetypen und gängige Raumvorlagen
  roomPresets: {
    buildingTypes: {
      allRooms: 'Alle Räume',
      home: 'Zuhause',
      house: 'Haus',
      office: 'Büro',
      school: 'Schule',
      hotel: 'Hotel',
      hospital: 'Krankenhaus',
    },
    rooms: {
      entrance_hall: 'Eingangshalle',
      living_room: 'Wohnzimmer',
      dining_room: 'Esszimmer',
      kitchen: 'Küche',
      pantry: 'Speisekammer',
      family_room: 'Familienzimmer',
      study: 'Arbeitszimmer',
      home_office: 'Homeoffice',
      library: 'Bibliothek',
      master_bedroom: 'Hauptschlafzimmer',
      bedroom: 'Schlafzimmer',
      bedroom_2: 'Schlafzimmer 2',
      bedroom_3: 'Schlafzimmer 3',
      bedroom_4: 'Schlafzimmer 4',
      guest_bedroom: 'Gästezimmer',
      kids_room: 'Kinderzimmer',
      master_bathroom: 'Hauptbad',
      bathroom: 'Badezimmer',
      powder_room: 'Gästebad',
      laundry: 'Waschküche',
      garage: 'Garage',
      workshop: 'Werkstatt',
      storage: 'Abstellraum',
      utility_room: 'Hauswirtschaftsraum',
      basement: 'Keller',
      wine_cellar: 'Weinkeller',
      home_theater: 'Heimkino',
      game_room: 'Spielzimmer',
      gym: 'Fitnessraum',
      patio: 'Patio',
      balcony: 'Balkon',
      terrace: 'Terrasse',
      garden: 'Garten',
      pool_area: 'Poolbereich',
      hallway: 'Flur',
      attic: 'Dachboden',
      reception: 'Empfang',
      office: 'Büro',
      meeting_room: 'Besprechungsraum',
      conference_room: 'Konferenzraum',
      break_room: 'Pausenraum',
      restroom: 'Toilette',
      server_room: 'Serverraum',
      classroom: 'Klassenzimmer',
      cafeteria: 'Cafeteria',
      gymnasium: 'Sporthalle',
      laboratory: 'Labor',
      playground: 'Spielplatz',
      lobby: 'Lobby',
      guest_room: 'Gästezimmer',
      suite: 'Suite',
      restaurant: 'Restaurant',
    },
  },
  // Common UI elements - buttons, actions, generic labels
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    remove: 'Entfernen',
    close: 'Schließen',
    back: 'Zurück',
    confirm: 'Bestätigen',
    ok: 'OK',
    loading: 'Laden...',
    saving: 'Speichern...',
    error: 'Fehler',
    more: 'Mehr',
    copy: 'Kopieren',
    all: 'Alle',
    language: 'Sprache',
    password: 'Passwort',
  },

  // Dialog- / Meldungsfeld-Texte (Bestätigen, Warnung, Toast)
  dialogs: {
    // Allgemein
    areYouSure: 'Sind Sie sicher?',
    typeDelete: '„DELETE“ eingeben',
    finalWarning: 'ENDWARNUNG. Alle Daten werden gelöscht. Fortfahren?',
    done: 'Fertig',
    errorWithMessage: 'Fehler: {message}',
    saveFailed: 'Änderungen konnten nicht gespeichert werden',
    validationErrors: 'Bitte beheben Sie die folgenden Fehler:\n{errors}',
    deleteAllConversationHistory:
      'Möchten Sie wirklich den gesamten Gesprächsverlauf löschen? Dies kann nicht rückgängig gemacht werden.',
    unregisterFromCloud: 'Von der Cloud abmelden? Der Fernzugriff wird deaktiviert.',
    removeUserAccess: 'Zugriff dieses Benutzers entfernen?',
    allDevicesDeleted: 'Alle Geräte gelöscht',
    allRoomsDeleted: 'Alle Räume gelöscht',
    allIntegrationsDeleted: 'Alle Integrationen gelöscht',
    allScenesDeleted: 'Alle Szenen gelöscht',
    factoryResetInitiated: 'Werksreset gestartet.',
    // Gerät
    deviceDeleteConfirm: 'Möchten Sie „{name}“ wirklich löschen?\n\nDies kann nicht rückgängig gemacht werden.',
    deviceDeleteConfirmShort: 'Möchten Sie dieses Gerät wirklich löschen?',
    deviceRemoveConfirm: 'Möchten Sie dieses Gerät wirklich entfernen?',
    deviceDeleteFailed: 'Gerät konnte nicht gelöscht werden',
    devicesDeleteFailed: 'Geräte konnten nicht gelöscht werden',
    deviceDeleteFailedMessage: 'Gerät konnte nicht gelöscht werden: {message}',
    deviceDuplicateFailed: 'Gerät konnte nicht dupliziert werden: {message}',
    deviceReorderFailed: 'Geräte-Reihenfolge konnte nicht aktualisiert werden',
    deviceReinitConfirm:
      'Dadurch werden alle Gerätewerte anhand der Definition des Gerätetyps gelöscht und neu erstellt. Benutzerdefinierte Werte bleiben erhalten. Referenzen (KNX-Adressen, Matter-Zuordnungen) gehen verloren und müssen neu konfiguriert werden. Fortfahren?',
    deviceReinitFailed: 'Gerätewerte konnten nicht neu initialisiert werden',
    deviceRefsSaveFailed: 'Referenzen konnten nicht gespeichert werden',
    deviceRefsUpdateFailed: 'Einige Referenzen konnten nicht aktualisiert werden:\n{errors}',
    customValueDeleteConfirm: 'Benutzerdefinierten Wert „{name}“ löschen?',
    thumbnailUploadFailed: 'Upload des Geräte-Thumbnails fehlgeschlagen: {message}',
    thumbnailRemoveFailed: 'Entfernen des Geräte-Thumbnails fehlgeschlagen: {message}',
    stateThumbnailUploadFailed: 'Upload des Statusbildes fehlgeschlagen: {message}',
    stateThumbnailRemoveFailed: 'Entfernen des Statusbildes fehlgeschlagen: {message}',
    deviceRoomUpdateFailed: 'Raum konnte nicht aktualisiert werden: {message}',
    // Widget / Dashboard
    widgetDeleteConfirm: 'Möchten Sie dieses Widget wirklich löschen?',
    widgetMissing:
      'Dieses Widget existiert nicht mehr. Es wurde möglicherweise entfernt. Die Widget-Liste wird aktualisiert.',
    widgetSaveFailed: 'Speichern fehlgeschlagen: {message}',
    widgetRemoveConfirm: 'Dieses Widget vom Dashboard entfernen?',
    dashboardRebuildConfirm: '„{name}“ als {label} neu erstellen? Vorhandene Widgets auf dieser Seite werden ersetzt.',
    dashboardDeleteConfirm: '„{name}“ löschen? Dies kann nicht rückgängig gemacht werden.',
    dashboardGroupDeleteConfirm: 'Gruppe „{name}“ löschen? Die Seiten dieser Gruppe werden entgruppiert.',
    dashboardGroupDeleteCountConfirm: 'Gruppe „{name}“ löschen? {count} Seite(n) werden entgruppiert.',
    // Raum
    roomExistsInDb: 'Der Raum „{name}“ existiert bereits in der Datenbank.',
    roomAlreadyInSelection: 'Der Raum „{name}“ ist bereits in Ihrer Auswahl.',
    roomsCreateFailed: 'Räume konnten nicht erstellt werden',
    roomUpdateFailed: 'Raum konnte nicht aktualisiert werden',
    // Szene
    sceneCreateFailed: 'Szene konnte nicht erstellt werden',
    sceneDeleteFailed: 'Szene konnte nicht gelöscht werden',
    sceneValuesSaveFailed: 'Szenenwerte konnten nicht gespeichert werden',
    sceneThumbnailUploadFailed: 'Thumbnail-Upload fehlgeschlagen',
    // Automatisierung
    automationCreateFailed: 'Funktion konnte nicht erstellt werden',
    automationSaveFailed: 'Funktion konnte nicht gespeichert werden',
    automationDeleteConfirm: 'Möchten Sie „{name}“ wirklich löschen?',
    automationDeleteFailed: 'Funktion konnte nicht gelöscht werden',
    automationDeleteFailedRetry: 'Funktion konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
    // Kalender
    calendarDeleteConfirm: '„{name}“ und alle zugehörigen Ereignisse löschen?',
    calendarSaveChanges: 'Möchten Sie Ihre Änderungen speichern?',
    calendarDiscardChanges: 'Nicht gespeicherte Änderungen verwerfen?',
    calendarDeleteEvent: '„{title}“ löschen?',
    // Kamera / Integration
    cameraDeleteRecording: 'Diese Aufnahme löschen? Alle Segmente werden dauerhaft entfernt.',
    cameraDeleteRecordingEvent: 'Dieses Aufnahmeereignis löschen? Alle Segmente werden dauerhaft gelöscht.',
    cameraDeleteConfirm: 'Kamera „{name}“ löschen? Alle Aufnahmen werden dauerhaft gelöscht.',
    cameraDeleteAllRecordings: 'ALLE Aufnahmen von „{name}“ löschen? Dies kann nicht rückgängig gemacht werden.',
    cameraResetSettings: 'Alle Streaming-Einstellungen auf Standardwerte zurücksetzen?',
    cameraToggleFailed: 'Integration konnte nicht umgeschaltet werden: {message}',
    cameraNameSaveFailed: 'Name konnte nicht gespeichert werden: {message}',
    cameraSettingsSaved: 'Kameraeinstellungen erfolgreich gespeichert',
    cameraSettingsSaveFailed: 'Kameraeinstellungen konnten nicht gespeichert werden: {message}',
    integrationConfigSaveFailed: 'Konfiguration konnte nicht gespeichert werden: {message}',
    knxNoInterfaces:
      'Keine KNX-IP-Schnittstellen im Netzwerk gefunden. Stellen Sie sicher, dass Ihre KNX-IP-Schnittstelle eingeschaltet und verbunden ist.',
    discoveryFailed: 'Erkennung fehlgeschlagen: {message}',
    devicesAddFailed: 'Einige Geräte konnten nicht hinzugefügt werden: {message}',
    // Galerie / Bilder
    imageDeleteConfirm: 'Möchten Sie dieses Bild wirklich löschen?',
    imageDeleteForEntity: '{type}-Bild für {entity} löschen?',
    imageReplaceForEntity: '{type}-Bild für {entity} ersetzen?',
    fileTooLarge: 'Datei ist zu groß (max. 50 MB)',
    fileDeleteConfirm: '„{name}“ löschen?',
    fileDeleteFailed: 'Löschen fehlgeschlagen',
    albumAddFailed: 'Hinzufügen zum Album fehlgeschlagen',
    albumRemoveFailed: 'Entfernen aus dem Album fehlgeschlagen',
    albumSaveFailed: 'Album konnte nicht gespeichert werden',
    albumDeleteConfirm: 'Album „{name}“ löschen? Fotos werden nicht gelöscht.',
    albumDeleteFailed: 'Album konnte nicht gelöscht werden',
    // Medien / Notizen
    mediaDeleteConfirm: '„{title}“ aus der Medienbibliothek löschen? Dadurch wird auch die Datei vom Server entfernt.',
    playlistDeleteConfirm: 'Diese Wiedergabeliste löschen?',
    zoneDeleteConfirm: 'Diese Zone löschen? Die Wiedergabe wird gestoppt und alle Mitglieder werden entfernt.',
    mediaPlayerRemoveConfirm: 'Diesen Mediaplayer entfernen?',
    coverPhotoUploadFailed: 'Upload des Titelbilds fehlgeschlagen',
    coverPhotoRemoveConfirm: 'Dieses Titelbild entfernen?',
    coverPhotoRemoveFailed: 'Titelbild konnte nicht entfernt werden',
    noteSaveFailed: 'Notiz konnte nicht gespeichert werden',
    noteDeleteConfirm: 'Diese Notiz und alle ihre Bilder löschen?',
    noteDeleteFailed: 'Notiz konnte nicht gelöscht werden',
    // Agent
    agentClearConversation: 'Diese Unterhaltung löschen?',
    logoutConfirm: 'Möchten Sie sich wirklich abmelden?',
    reminderDeleteConfirm: 'Diesen Erinnerung löschen?',
    // Shopping
    shoppingListSaveFailed: 'Liste konnte nicht gespeichert werden',
    shoppingListDeleteConfirm: 'Diese Liste und alle ihre Artikel löschen?',
    shoppingListDeleteFailed: 'Liste konnte nicht gelöscht werden',
    shoppingItemAddFailed: 'Artikel konnte nicht hinzugefügt werden',
    shoppingClearCheckedConfirm: 'Alle markierten Artikel entfernen?',
    shoppingClearFailed: 'Artikel konnten nicht gelöscht werden',
    shoppingStoreAddFailed: 'Geschäft konnte nicht hinzugefügt werden',
    shoppingStoreDeleteConfirm:
      'Dieses Geschäft löschen? Listen bleiben erhalten, verlieren aber die Geschäftszuordnung.',
    shoppingStoreDeleteFailed: 'Geschäft konnte nicht gelöscht werden',
    // Integration (Matter / Z-Wave / Zigbee / Überwachung)
    monitoringStartFailed: 'Überwachung konnte nicht gestartet werden: {message}',
    monitorWriteFailed: 'Schreiben fehlgeschlagen: {message}',
    monitorReadFailed: 'Lesen fehlgeschlagen: {message}',
    mqttPropertyDeleteConfirm: 'Diese MQTT-Eigenschaft löschen? Vorhandene Geräteverweise werden entfernt.',
    modbusRegisterDeleteConfirm: 'Dieses Modbus-Register löschen? Vorhandene Geräteverweise werden entfernt.',
    knxDatapointDeleteConfirm: 'Diese KNX-Gruppenadresse löschen? Vorhandene Geräteverweise werden entfernt.',
    commissioningWindowFailed: 'Commissioning-Fenster konnte nicht geöffnet werden',
    matterDeviceUpdateFailed: 'Gerät konnte nicht aktualisiert werden',
    matterDeviceSaveFailed: 'Gerät konnte nicht gespeichert werden',
    matterDeleteFailed: 'Löschen fehlgeschlagen',
    matterError: '❌ Fehler: {message}',
    matterReinterviewConfirm:
      'Knoten {id} erneut interviewen? Dadurch werden alle Geräte dieses Knotens gelöscht und neu erstellt.',
    matterDecommissioned: '✅ Matter-Knoten erfolgreich außer Betrieb genommen und gelöscht',
    matterNodeDeleteError: '❌ Fehler beim Löschen des Knotens: {message}',
    matterNodeRemoveTitle: 'Matter-Knoten entfernen',
    matterNodeRemoveInspecting: 'Knoten wird geprüft …',
    matterNodeRemoveDecommission: 'Der Controller kennt diesen Knoten noch — er wird zuerst außer Betrieb genommen, dann werden seine Zeilen entfernt.',
    matterNodeRemoveGhost: 'Der Controller kennt diesen Knoten nicht (Speicher wurde zurückgesetzt oder der Knoten gehört zu einem anderen Fabric). Seine Zeilen werden ohne Controller-Aufruf entfernt.',
    matterNodeRemovePruneCounts: 'Zu entfernende Zeilen: {endpoints} Endpunkt(e), {clusters} Cluster, {properties} Attributzeilen.',
    matterNodeRemoveControllerOffline: 'Der Matter-Controller läuft nicht, daher kann nicht entschieden werden, ob der Knoten außer Betrieb genommen oder nur gelöscht wird. Starten Sie zuerst diese Integration — der Hub löscht keine Zeilen, die er nicht prüfen kann.',
    matterNodeRemoveDevicesFlag: 'Auch die {count} aus diesem Knoten erstellten Geräte löschen (unten aufgeführt)',
    matterNodeRemoveDetach: '{count} Gerät(e) aus einer anderen Integration werden nur von diesem Knoten getrennt, nicht gelöscht.',
    matterNodeRemoveOtherIntegration: 'andere Integration',
    matterNodeRemoveConfirm: 'Knoten entfernen',
    matterNodeRemoving: 'Wird entfernt …',
    matterNodeRemoved: '✅ Knoten entfernt — {endpoints} Endpunkte, {clusters} Cluster, {properties} Attributzeilen, {devices} Gerät(e).',
    matterNodeGhostHint: 'Nicht im Matter-Controller — dieser Knoten ist nie steuerbar.',
    matterNodeRemoveAction: 'Entfernen',
    matterDiagnosticsFailed: 'Diagnose konnte nicht abgerufen werden: {message}',
    matterFabricResetConfirm:
      '⚠️ Matter-Fabric zurücksetzen?\n\nDies wird:\n- Alle Matter-Speicher und Anmeldedaten löschen\n- Eine neue Fabric-ID generieren\n- Alle kommissionierten Geräte entfernen\n- Eine erneute Kommissionierung aller Geräte erfordern\n\nDiese Aktion kann NICHT rückgängig gemacht werden. Fortfahren?',
    matterFabricResetSuccess:
      '✅ Fabric-Reset erfolgreich!\n\nDer Matter-Controller wird mit einer neuen Fabric-ID neu gestartet.\nBitte aktualisieren Sie die Seite in einigen Sekunden.',
    matterFabricResetFailed: '❌ Fabric-Reset fehlgeschlagen: {message}',
    factoryResetFailed: 'Werksreset fehlgeschlagen',
    matterDeviceRemoveFailed: 'Gerät konnte nicht entfernt werden',
    threadSaveFailed:
      'Thread-Dataset konnte nicht gespeichert werden. Das Feature ist auf dem Hub möglicherweise noch nicht implementiert.',
    zigbeeGroupDeleteConfirm: 'Gruppe {id} löschen?',
    remoteSupportEndSessionFailed: 'Sitzung konnte nicht beendet werden',
    remoteSupportSendMessageFailed: 'Nachricht konnte nicht gesendet werden',
    zigbeeNodeRemoveConfirm: 'Knoten {id} entfernen?',
    zwaveNodeRemoveConfirm: 'Knoten {id} aus der Datenbank entfernen?',
    zwaveNodeRenameFailed: 'Knoten konnte nicht umbenannt werden',
    zwaveEndpointRenameFailed: 'Endpunkt konnte nicht umbenannt werden',
    wifiSaveFailed:
      'WiFi-Anmeldedaten konnten nicht gespeichert werden. Das Feature ist auf dem Hub möglicherweise noch nicht implementiert.',
    touchPanelUnpairConfirm: '„{name}“ entkoppeln? Das Gerät muss neu gekoppelt werden.',
    mapZoneDeleteConfirm: 'Zone „{name}“ löschen?',
    securityPinRemoveConfirm: 'PIN für geheime Geräte entfernen? Geheime Kameras sind dann ohne PIN zugänglich.',
    // Einstellungen
    scheduleEditorComingSoon:
      'Der Zeitplan-Editor folgt in Kürze. Konfigurieren Sie Gerätezeitpläne über die API oder die Energieseite.',
    libraryDeleteConfirm: 'Diesen Eintrag löschen?',
    securityModeDeleteConfirm: 'Diesen Sicherheitsmodus löschen? Dies kann nicht rückgängig gemacht werden.',
    remoteSupportRemoveUserFailed: 'Benutzer konnte nicht entfernt werden',
    remoteSupportUpdateAccessFailed: 'Zugriff konnte nicht aktualisiert werden',
    // Benutzer
    userSaveFailed: 'Benutzer konnte nicht gespeichert werden',
    userDeleteFailed: 'Benutzer konnte nicht gelöscht werden: {message}',
    profilePictureRemoveConfirm: 'Möchten Sie Ihr Profilbild wirklich entfernen?',
    // Server
    serverRemoveFromCloud: `„{hub}“ aus ${brand.agentName} Cloud entfernen?\n\nWarnungen:\n- Freigegebene Zugriffe für diesen Server werden gelöscht.\n- Der lokale ${brand.agentName}-Server läuft weiter.\n- Um wieder in der Cloud zu erscheinen, muss sich der Server erneut verbinden und registrieren.\n\nDiese Aktion kann nicht rückgängig gemacht werden.`,
    // Editor
    imageUrlMissing: 'Upload erfolgreich, aber es wurde keine Bild-URL zurückgegeben.',
    imageUploadFailed: 'Bild-Upload fehlgeschlagen',
  },

  // Authentication
  auth: {
    signIn: 'Anmelden',
    emailAddress: 'E-Mail-Adresse',
    passwordPlaceholder: 'Passwort eingeben',
    signInToYourHub: 'Bei Ihrem Hub anmelden',
    signInToOttoHome: `Bei ${brand.platformCompact} anmelden`,
    signingIn: 'Anmeldung läuft...',
    invalidCredentials: 'Ungültige E-Mail oder Passwort',
    // No "Forgot password?" link on the sign-in form: the hub serves no
    // forgot/reset route any more (PLAN.md §4 phase 4, hub commit 51677c7),
    // so this sentence is the whole answer the form can honestly give.
    noPasswordReset:
      'Kein Zur\u00fccksetzen des Passworts: Dieser Hub vergibt Zugang per Einladung, nicht per E-Mail. Bitten Sie einen Administrator um eine Einladung oder verbinden Sie dieses Ger\u00e4t \u00fcber die App.',
    genericError: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    secureSmartHome: 'Sicherer Zugang zu Ihrem Smart Home',
    usernameOrEmail: 'Benutzername oder E-Mail',
    setupWizardTitle: 'Ihr Hub einrichten',
    setupWelcome: 'Willkommen! In wenigen Schritten ist Ihr Hub bereit.',
    setupStepSettingsTitle: 'Systemeinstellungen',
    setupStepSettingsDesc: 'Geben Sie Ihrem Hub einen Namen und ein Bild, damit er leicht zu erkennen ist.',
    setupStepCloudTitle: 'Mit Cloud registrieren (optional)',
    setupStepCloudDesc:
      'Die Registrierung ermöglicht E-Mail, Push-Benachrichtigungen und Fernzugriff. Cloud-Dienste sind kostenpflichtig.',
    setupSystemNamePlaceholder: 'z. B. Mein Zuhause',
    setupUploadImage: 'Bild hochladen',
    setupNext: 'Weiter',
    setupBack: 'Zurück',
    setupFinish: 'Fertigstellen',
    setupSkip: 'Überspringen',
    setupCloudPricing: 'Preise ansehen',
    setupCloudRegistered: 'Mit Cloud registriert',
  },

  // Navigation & Sidebar
  nav: {
    dashboard: 'Dashboard',
    home: 'Zuhause',
    rooms: 'Räume',
    devices: 'Geräte',
    cameras: 'Kameras',
    security: 'Sicherheit',
    climate: 'Klima',
    water: 'Wasser',
    appliances: 'Geräte',
    wellness: 'Wellness',
    lights: 'Lichter',
    shades: 'Beschattung',
    energy: 'Energie',
    weather: 'Wetter',
    maintenance: 'Wartung',
    apps: 'Apps',
    main: 'Haupt',
    settings: 'Einstellungen',
    media: 'Medien',
    intercom: 'Gegensprechanlage',
    map: 'Karte',
  },

  roomsNav: {
    allRooms: 'Alle Räume',
    unassigned: 'Nicht zugewiesen',
  },

  // Settings & System
  settings: {
    settingsUpdates: {
      hubUpdateTitle: 'Hub-Update verfügbar',
      hubUpdateBody:
        'Ein neues Hub-Update ist verfügbar: v{version}. Öffnen Sie Einstellungen → System → Appliance-Update, um es zu installieren.',
      checkUpdates: 'Nach Updates suchen',
      checking: 'Suche...',
      updateFailed: 'Update fehlgeschlagen',
      downloadingUpdate: 'Update wird heruntergeladen...',
      updateReady: 'Update bereit — Neustart zum Installieren',
      restartInstall: 'Neu starten & installieren',
      upToDate: 'Sie verwenden die neueste Version',
      appUpdate: 'App-Update',
      checkFailed: 'Update-Prüfung fehlgeschlagen',
    },
    // Addon service cards (settings/AddonServicesSection.vue): the voice
    // services and the browser & automation addon the hub runs as containers.
    addons: {
      services: 'Dienste',
      refresh: 'Aktualisieren',
      noServices: 'Keine Dienste verfügbar.',
      status: {
        running: 'Läuft',
        stopped: 'Gestoppt',
        notInstalled: 'Nicht installiert',
        installing: 'Wird installiert',
        updating: 'Wird aktualisiert',
        uninstalling: 'Wird deinstalliert',
        error: 'Fehler',
      },
      start: 'Starten',
      stop: 'Stoppen',
      install: 'Installieren',
      logs: 'Protokolle',
      logsTitle: 'Protokolle (letzte 100 Zeilen)',
      generateFromDevices: 'Aus Geräten erzeugen',
      generating: 'Wird erzeugt...',
      availableCommands: 'Verfügbare Befehle',
      saveRestart: 'Speichern & neu starten',
      savingRestart: 'Speichern & neu starten...',
      savedRestarting: 'Gespeichert — Container wird neu gestartet',
      errorPrefix: 'Fehler:',
      errorLoad: 'Dienste konnten nicht geladen werden',
      errorSaving: 'Fehler beim Speichern der Konfiguration',
      errorStart: 'Dienst konnte nicht gestartet werden',
      errorStop: 'Dienst konnte nicht gestoppt werden',
      errorInstall: 'Dienst konnte nicht installiert werden',
    },
  },

  // Settings Sidebar Navigation
  settingsNav: {
    configuration: 'Konfiguration',
    general: 'Allgemein',
    torikApi: 'Torik API',
    automations: 'Automatisierungen',
    rooms: 'Räume',
    devices: 'Geräte',
    functions: 'Funktionen',
    modes: 'Modi',
    integrations: 'Integrationen',
    security: 'Sicherheit',
    energy: 'Energie',
    weather: 'Wetter',
    climate: 'Klima',
    water: 'Wasser',
    appliances: 'Geräte',
    lights: 'Beleuchtung',
    shades: 'Beschattung',
    scenes: 'Szenen',
    routines: 'Routinen',
    charts: 'Diagramme',
    system: 'System',
    users: 'Benutzer',
    presence: 'Anwesenheitsverfolgung',
    agent: 'Agent',
    demo: 'Demo',
    backup: 'Sicherung',
    library: 'Bibliothek',
    dashboards: 'Dashboards',
    gallery: 'Galerie',
    model: '3D-Modell',
    installer: 'Installateur',
    logs: 'Protokolle',
    dangerZone: 'Gefahrenzone',
  },

  // Views - Nested object for all view sections
  views: {
    // Map view (views/Map.vue + components/map/MapZonePanel.vue): the hub's own
    // geofence zones and the cloud areas the cloud owns (card `t_6b57f8f2`, plan
    // docs/plans/GEOFENCING-E2E.md §2.4). `cloudRefusal*` are read indirectly
    // (`cloudAreaRefusalNotice(...).key`) — see locales/localeAudit.ts.
    map: {
      title: 'Geofence-Zonen',
      empty: 'Noch keine Zonen. Erstelle eine mit „Zone hinzufügen“.',
      radiusMeters: 'Radius {meters} m',
      flyTo: 'Zur Zone springen',
      editZone: 'Zone bearbeiten',
      deleteZone: 'Zone löschen',
      zoneName: 'Zonenname',
      radiusShort: 'Radius (m)',
      radiusMetersLabel: 'Radius (Meter)',
      lat: 'Breite',
      lon: 'Länge',
      newZone: 'Neue Zone',
      globalZone: 'Globale Zone (für alle Benutzer sichtbar)',
      createZone: 'Zone erstellen',
      clickHint: 'Klicken Sie auf die Karte, um eine neue Zone zu erstellen',
      addZone: 'Zone hinzufügen',
      moveHint: 'Bereich auswählen und am Griff ziehen, um ihn zu verschieben',
      layerUsers: 'Benutzer',
      layerZones: 'Zonen',
      centerOnHub: 'Auf Hub zentrieren',
      manageZones: 'Zonen verwalten',
      hubMarker: 'Hub',
      sourceLocal: 'Auf diesem Server',
      sourceCloud: 'Cloud-Bereich',
      cloudManaged: 'Cloud-verwaltet',
      cloudTitle: 'Cloud-Bereiche',
      cloudAdd: 'Cloud-Bereich hinzufügen',
      cloudPickHint: 'Klicken Sie auf die Karte, um den neuen Cloud-Bereich zu platzieren',
      cloudLoading: 'Cloud-Bereiche werden geladen…',
      cloudEmpty: 'Noch keine Cloud-Bereiche.',
      cloudRetry: 'Erneut versuchen',
      cloudAdminOnly: 'Nur ein Serverinhaber oder Administrator kann die Cloud-Bereiche ändern.',
      cloudAreaName: 'Bereichsname',
      cloudCreate: 'Bereich erstellen',
      cloudDeleteConfirm: 'Cloud-Bereich „{name}“ löschen?',
      cloudRefusalForbidden: 'Dieses Konto darf die Cloud-Bereiche dieses Servers nicht ändern.',
      cloudRefusalNotMember: 'Dieses Konto hat keine Rolle auf diesem Server.',
      cloudRefusalNotAdmin: 'Nur ein Serverinhaber oder Administrator kann die Cloud-Bereiche ändern.',
      cloudRefusalNotFound: 'Dieser Cloud-Bereich existiert nicht mehr.',
      cloudRefusalInvalidRadius: 'Der Radius muss zwischen 50 und 5000 Metern liegen.',
      cloudRefusalInvalidArea: 'Name und Position des Bereichs prüfen.',
      cloudRefusalGeneric: 'Die Cloud hat die Änderung abgelehnt.',
    },

    // Rooms view
    rooms: {
      pageTitle: 'Räume',
      searchPlaceholder: 'Nach Raum oder Bereich suchen...',
      loading: 'Laden...',
      emptyTitle: 'Keine Räume',
      emptyDescription: 'Erstellen Sie einen neuen Raum, um zu beginnen.',
      noResultsTitle: 'Keine Räume gefunden',
      noResultsDescription: 'Versuchen Sie einen anderen Suchbegriff.',
      unassignedRoomsSectionTitle: 'Nicht zugewiesene Räume',
      loadError: 'Daten konnten nicht geladen werden',
    },

    // Raumscan (Karte `t_90febbcf`, A2): Einstieg und Panel
    // (`components/scan/RoomScanEntry.vue` + `RoomScanPanel.vue`). Gescannt wird
    // vom nativen Plugin `RoomScan` (iOS, LiDAR); `unsupported*` sind die ehrlichen
    // Antworten eines Geräts ohne LiDAR (Plan §7).
    // 3D-Scans (Karte `t_8ae1d20a`, E2): die Einstellungsseite, die die auf
    // DIESEM Hub gespeicherten Scans listet (`views/Settings/SettingsModel.vue`),
    // mit Hochladen, Ersetzen, Herunterladen und Löschen.
    model: {
      title: '3D-Modell',
      subtitle: 'Das eine 3D-Modell dieses Hubs — und die Scans, aus denen es entstehen kann.',
      homeTitle: '3D-Modell des Hauses',
      homeIntro: 'Jede Seite, die das Haus zeigt, rendert diese Bytes — es gibt ein Modell pro Hub.',
      upload: 'Modell hochladen …',
      replace: 'Ersetzen …',
      download: 'Herunterladen',
      delete: 'Löschen',
      active: 'Aktiv',
      updated: 'Aktualisiert',
      loading: 'Modell wird gelesen …',
      loadFailed: 'Das Modell des Hubs konnte nicht gelesen werden',
      empty: 'Noch kein 3D-Modell auf diesem Hub — laden Sie eine IFC-, GLB- oder glTF-Datei hoch oder verwenden Sie unten einen 3D-Scan.',
      uploading: 'Modell wird hochgeladen …',
      uploadDone: 'Das Modell wurde hochgeladen.',
      uploadFailed: 'Das Modell konnte nicht hochgeladen werden',
      badFormat: 'Bitte wählen Sie eine IFC- (.ifc), GLB- (.glb) oder glTF-Datei (.gltf).',
      tooLarge: 'Die Modelldatei muss kleiner als 200 MB sein.',
      downloading: 'Modell wird heruntergeladen …',
      downloadDone: 'Das Modell wurde als „{name}“ gespeichert.',
      downloadFailed: 'Das Modell konnte nicht heruntergeladen werden',
      deleting: 'Modell wird entfernt …',
      deleteTitle: '3D-Modell entfernen',
      deleteMessage:
        'Das 3D-Modell des Hubs „{name}“ entfernen? Jede Seite, die das Haus zeigt, verliert es, und die 3D-Ansicht bleibt leer, bis ein anderes Modell hochgeladen wird.',
      deleteDone: '„{name}“ wurde entfernt.',
      deleteFailed: 'Das Modell konnte nicht gelöscht werden',
      scanIsModel: '„{name}“ ist jetzt das 3D-Modell des Hubs.',
    },
    scans: {
      title: '3D-Scans',
      subtitle: 'Raumscans auf diesem Hub. Scannen Sie einen Raum mit der Kamera oder laden Sie ein Scan-Paket vom Telefon hoch.',
      scanRoom: 'Einen Raum scannen',
      scanRoomHint: 'Ein fertiger Scan wird von selbst auf diesen Hub hochgeladen.',
      uploadPackage: 'Paket hochladen',
      refresh: 'Aktualisieren',
      hubTitle: 'Auf dem Hub',
      deviceTitle: 'Aufnahmen auf diesem Gerät',
      deviceEmpty: 'Auf diesem Gerät gibt es noch keine Aufnahmen.',
      deviceOnHub: 'Auf dem Hub',
      deviceUpload: 'Hochladen',
      loading: 'Scans werden geladen …',
      loadFailed: 'Die Scans konnten von diesem Hub nicht geladen werden',
      emptyTitle: 'Noch keine Scans — scannen Sie Ihren ersten Raum',
      emptyHint:
        'Ein Scan-Paket ist der Ordner, den eine Aufnahme schreibt (scan.json, model.usdz, der Plan …). Laden Sie eines hier hoch oder scannen Sie mit der App.',
      modeRoom: 'Ein Raum',
      modeStructure: 'Stockwerk',
      rooms: '{count} Raum | {count} Räume',
      files: '{count} Datei | {count} Dateien',
      capturedAt: 'Aufgenommen',
      updatedAt: 'Aktualisiert',
      download: 'Herunterladen',
      replace: 'Ersetzen',
      delete: 'Löschen',
      close: 'Schließen',
      retry: 'Erneut versuchen',
      working: 'Arbeitet …',
      reading: 'Die Aufnahme wird von diesem Gerät gelesen …',
      uploading: 'Wird auf den Hub hochgeladen …',
      replacing: 'Wird auf dem Hub ersetzt …',
      downloading: 'Wird vom Hub heruntergeladen …',
      progress: '{percent} % hochgeladen',
      progressUnknown: 'Der Hub empfängt das Paket …',
      uploadDone: '"{name}" ist auf dem Hub.',
      replaceDone: '"{name}" wurde ersetzt.',
      deleteDone: '"{name}" wurde vom Hub gelöscht.',
      downloadDone: '"{name}" gespeichert — {count} Datei | "{name}" gespeichert — {count} Dateien',
      deleteTitle: 'Diesen Scan löschen?',
      deleteMessage: '"{name}" vom Hub löschen? Die Dateien werden mit ihm entfernt, das lässt sich nicht rückgängig machen.',
      validationTitle: 'Dieses Paket wurde nicht gesendet',
      replaceTitle: '"{name}" ersetzen',
      replaceHint: 'Das neue Paket nimmt den Platz des Scans ein — die jetzigen Dateien werden entfernt.',
      replaceChooseCapture: 'Eine Aufnahme auf diesem Gerät',
      replaceChooseFiles: 'Dateien von diesem Gerät wählen …',
      replaceNoCaptures: 'Keine Aufnahmen auf diesem Gerät.',
      replaceUseCapture: 'Diese Aufnahme verwenden',
      invalid: {
        empty: 'Wählen Sie zuerst die Dateien eines Scan-Pakets.',
        tooManyFiles: 'Ein Paket enthält höchstens {max} Dateien.',
        fileTooLarge: '"{name}" ist größer als {max} MB.',
        packageTooLarge: 'Das Paket ist größer als {max} MB.',
        badFileName: '"{name}" kann nicht gespeichert werden — ein Paketname hat keinen Pfad, keinen führenden Punkt und endet nicht mit Punkt oder Leerzeichen.',
        duplicateName: '"{name}" ist zweimal im Paket.',
        missingUsdz: 'Das Paket braucht die Geometrie des Raums — eine .usdz-Datei.',
        badScanDoc: 'Die scan.json ist kein torik.scan/v0-Dokument.',
        generic: 'Das Paket kann so nicht gesendet werden.',
      },
      warnings: {
        missingScanDoc: 'Keine scan.json im Paket — der Hub speichert es als Aufnahme auf Raumebene.',
      },
      errors: {
        noHub: 'Dieser Hub ist gerade nicht erreichbar.',
        auth: 'Der Hub hat diese Sitzung abgelehnt — melden Sie sich erneut an.',
        validation: 'Der Hub hat das Paket abgelehnt.',
        readFailed: 'Die Aufnahme konnte von diesem Gerät nicht gelesen werden.',
        uploadFailed: 'Das Hochladen wurde nicht beendet.',
        downloadFailed: 'Das Herunterladen wurde nicht beendet.',
        saveFailed: 'Die Datei konnte auf diesem Gerät nicht gespeichert werden.',
        unknown: 'Die Übertragung wurde nicht beendet.',
      },
      model: {
        title: '3D scannen',
        intro: 'Scannen Sie einen Raum mit der Kamera — eine fertige Aufnahme wird von selbst auf diesen Hub hochgeladen, und jeder Scan hier kann das 3D-Modell des Hauses auf diesem Hub werden.',
        scan3d: '3D scannen',
        empty: 'Noch keine Scans auf diesem Hub — beginnen Sie mit „3D scannen“.',
        useScan: 'Als Modell verwenden',
        selected: 'Als Modell gewählt',
        noModel: 'Keine Modelldatei in diesem Paket',
        loadingFile: 'Der Scan wird vom Hub gelesen …',
        attaching: 'Der Scan wird als 3D-Modell des Hubs angehängt …',
        fetchFailed: 'Der Scan konnte nicht vom Hub gelesen werden',
        attachFailed: 'Der Scan konnte nicht zum 3D-Modell des Hubs werden',
      },
    },

    roomScan: {
      entryTitle: 'Räume mit der Kamera scannen',
      entry: 'Scannen',
      title: 'Raumscan',
      checking: 'Es wird geprüft, ob dieses Gerät scannen kann …',
      unsupportedTitle: 'Dieses Gerät kann keine Räume scannen',
      unsupportedLidar: 'RoomPlan benötigt ein iPhone Pro oder iPad Pro — den Raum vermisst der LiDAR-Scanner.',
      unsupportedPlatform: 'Der Raumscan läuft in der Torik-App auf einem iPhone Pro oder iPad Pro (LiDAR).',
      errorTitle: 'Der Scan wurde nicht abgeschlossen',
      nameLabel: 'Name für diesen Scan (optional)',
      namePlaceholder: 'z. B. Wohnzimmer',
      startRoom: 'Einen Raum scannen',
      startStructure: 'Ein ganzes Stockwerk scannen',
      startHint: 'Die Kameransicht führt Sie durch — bewegen Sie sich langsam und sorgen Sie für Licht.',
      capturingRoom: 'Der Raum wird erfasst …',
      capturingRoomFloor: 'Dieser Raum des Stockwerks wird erfasst …',
      capturingHint: 'Gehen Sie den Raum ab und tippen Sie dann in der Kameransicht auf Fertig.',
      structureRooms: 'Erfasste Räume: {count}',
      structureHint: 'Jedes „Fertig“ speichert einen Raum; „Abschließen“ führt sie zu einem Modell zusammen.',
      scanAnother: 'Weiteren Raum scannen',
      finish: 'Abschließen',
      saved: 'Gespeichert: {label} · {count} Raum | Gespeichert: {label} · {count} Räume',
      scanFile: 'Modelldaten',
      capturesTitle: 'Auf diesem Gerät',
      capturesEmpty: 'Auf diesem Gerät gibt es noch keine Scans.',
      modeRoom: 'Ein Raum',
      modeStructure: 'Stockwerk',
      rooms: '{count} Raum | {count} Räume',
      deleteConfirm: 'Den Scan „{label}“ löschen? Bis der Upload verfügbar ist, existiert er nur auf diesem Gerät.',
    },

    // Devices view
    devices: {
      pageTitle: 'Geräte',
      searchPlaceholder: 'Geräte durchsuchen...',
      groupByRooms: 'Räume',
      groupByTypes: 'Typen',
      loading: 'Lade Geräte...',
      noResultsTitle: 'Keine Geräte gefunden',
      noResultsDescription: 'Versuchen Sie einen anderen Suchbegriff.',
      emptyTitle: 'Keine Geräte',
      emptyDescription: 'Fügen Sie ein neues Gerät hinzu, um zu beginnen.',
      noRoomLabel: 'Kein Raum',
      noRoomsWithDevicesTitle: 'Keine Räume mit Geräten',
      noRoomsWithDevicesDescription:
        'Fügen Sie Geräte hinzu und weisen Sie sie Räumen zu, um sie hier organisiert zu sehen.',
      unknownType: 'Unbekannter Typ',
      emptyTypeViewDescription: 'Fügen Sie Geräte hinzu, um sie nach Typ organisiert zu sehen.',
      deleteConfirmTitle: 'Gerät löschen',
      deleteConfirmMessage: 'Sind Sie sicher, dass Sie {deviceName} löschen möchten?',
      cancelButton: 'Abbrechen',
      deleteButton: 'Löschen',
      deletingButton: 'Lösche...',
      loadError: 'Daten konnten nicht geladen werden',
    },

    // Scenes view
    scenes: {
      pageTitle: 'Szenen',
      searchPlaceholder: 'Szenen durchsuchen...',
      addSceneButton: 'Szene hinzufügen',
      reorderButton: 'Neu anordnen',
      doneButton: 'Fertig',
      cancelButton: 'Abbrechen',
      deleteButton: 'Löschen',
      loading: 'Laden',
      emptyTitle: 'Noch keine Szenen',
      emptyDescription: 'Erstellen Sie eine Szene, um zu beginnen.',
      noResultsTitle: 'Keine übereinstimmenden Szenen',
      deleteConfirmTitle: 'Szene löschen',
      deleteConfirmMessage: 'Sind Sie sicher, dass Sie löschen möchten?',
      loadError: 'Szenen konnten nicht geladen werden',
      executionSuccess: 'Szene erfolgreich ausgeführt',
      executionError: 'Ausführung mit Fehlern abgeschlossen',
    },

    // Routines view
    routines: {
      pageTitle: 'Routinen',
      loading: 'Routinen werden geladen...',
      createButton: 'Routine erstellen',
      editButton: 'Bearbeiten',
      runNowButton: 'Jetzt ausführen',
      emptyTitle: 'Noch keine Routinen',
      emptyDescription: 'Erstellen Sie Ihre erste Routine, um Ihr Smart Home zu automatisieren',
      triggerCount: 'Auslöser | Auslöser',
      conditionCount: 'Bedingung | Bedingungen',
      actionCount: 'Aktion | Aktionen',
      deleteConfirmMessage: 'Sind Sie sicher, dass Sie diese Routine löschen möchten?',
      loadError: 'Routinen konnten nicht geladen werden',
      deleteError: 'Routine konnte nicht gelöscht werden',
      enabledMessage: 'Routine aktiviert',
      disabledMessage: 'Routine deaktiviert',
      deletedMessage: 'Routine gelöscht',
      executionStartedMessage: 'Routineausführung gestartet',
      executionError: 'Routine konnte nicht ausgeführt werden',
    },

    // Media view
    media: {
      audioZonesTitle: 'Audiozonen',
      newZoneButton: 'Neue Zone',
      createZoneTitle: 'Zone erstellen',
      noAudioZonesTitle: 'Noch keine Audiozonen',
      noAudioZonesDescription: 'Erstellen Sie eine Zone und fügen Sie Panels oder Apps hinzu.',
      pausedLabel: 'Pausiert',
      noMediaPlayersTitle: 'Keine Media-Player',
      noMediaPlayersDescription: 'Fügen Sie eine Media-Integration hinzu, um Player zu entdecken.',
      goToIntegrations: 'Zu Integrationen',
      noLocalMediaMessage: 'Noch keine Medien in der Bibliothek.',
    },

    // Cameras view
    cameras: {
      pageTitle: 'Kameras',
      liveTab: 'Live',
      playbackTab: 'Wiedergabe',
      onlineLabel: 'online',
      intercomLabel: 'Gegensprechanlage',
      unlockSecretCamerasTitle: 'PIN eingeben, um geheime Kameras anzuzeigen',
      secretButton: 'Geheim',
      editButton: 'Bearbeiten',
      doneButton: 'Fertig',
      secretCameraTitle: 'Geheime Kamera - verborgen vor Gästen',
      loading: 'Lade Kameras...',
      noCamerasFoundMessage: 'Keine Kameras gefunden. Fügen Sie Kameras in den Integrationseinstellungen hinzu.',
      refreshSnapshotTitle: 'Schnappschuss aktualisieren',
      privacyBlurTitle: 'Datenschutz-Unschärfe',
      privacyBlurMenuTitle: 'Unschärfedauer',
      blur5Min: '5 Minuten',
      blur15Min: '15 Minuten',
      blur30Min: '30 Minuten',
      blur1Hour: '1 Stunde',
      blur2Hours: '2 Stunden',
      removeBlurButton: 'Unschärfe entfernen',
      muteMotionNotificationsTitle: 'Bewegungsbenachrichtigungen stummschalten',
      muteMotionNotificationsMenuTitle: 'Bewegungsbenachrichtigungen stummschalten für',
      unmuteMotionNotificationsButton: 'Bewegungsbenachrichtigungen wieder aktivieren',
      intercomBadge: 'Gegensprechanlage',
      callDoorphoneTitle: 'Türsprechanlage rufen',
      editModeInstructions:
        'Pfeile zum Neuordnen verwenden · Klicken Sie auf das Schloss, um es als geheim zu markieren',
      cancelButton: 'Abbrechen',
      savingButton: 'Speichern...',
      saveOrderButton: 'Reihenfolge speichern',
      selectCamerasMessage: 'Wählen Sie oben Kameras aus, um die Wiedergabe zu starten',
      // Eine Live-Ansicht, deren ICE nie abgeschlossen wird: Die WHEP-Antwort der
      // Kamera wurde angenommen, ein Medienpfad kam nicht zustande.
      // `services/mediaPath.ts` begrenzt das Warten und benennt den Zustand; die
      // Player zeigen diesen Satz (Karte t_20b35b28).
      mediaPathFailed:
        'Der Medienpfad zu dieser Kamera konnte nicht aufgebaut werden — sie hat die Anfrage angenommen, aber es kam keine Video- oder Audioverbindung zustande. Versuchen Sie es erneut, öffnen Sie die eigene App der Kamera oder prüfen Sie das go2rtc-Protokoll auf dem Hub.',
      // Warum der Versuch endete, unter dem Satz (Karte t_4d5b3263): die drei
      // Ursachen verlangen unterschiedliche nächste Schritte, und nur die
      // Ursache steht auf dem Bildschirm — die Kandidaten-Erhebung und die
      // Zeiten bleiben in der Konsole und in den Warnungen von
      // `services/mediaPath.ts`.
      mediaPathReasonBudget:
        'Kein Netzwerkpfad zur Kamera kam zustande — die Ursache ist meist das Netzwerk des Hubs, nicht die Kamera.',
      mediaPathReasonFailed:
        'Der Netzwerkpfad zur Kamera ist fehlgeschlagen — prüfen Sie das Netzwerk des Hubs, bevor Sie es erneut versuchen.',
      mediaPathReasonNoCandidates: 'Dieses Gerät konnte keine Verbindung zur Kamera vorbereiten.',
    },

    // Account view
    account: {
      profileInformationTitle: 'Profilinformationen',
      profilePictureLabel: 'Profilbild',
      changePictureButton: 'Bild ändern',
      pictureFormatHint: 'PNG oder JPG (max. 2MB)',
      fullNameLabel: 'Vollständiger Name',
      fullNamePlaceholder: 'Ihren vollständigen Namen eingeben',
      emailLabel: 'E-Mail-Adresse',
      emailPlaceholder: "benutzer{'@'}beispiel.de",
      phoneLabel: 'Telefonnummer',
      phonePlaceholder: '+49 (555) 123-4567',
      bioLabel: 'Über mich',
      bioPlaceholder: 'Erzählen Sie etwas über sich',
      saveProfileButton: 'Profil speichern',
      savingButton: 'Speichere...',
      securitySettingsTitle: 'Sicherheitseinstellungen',
      changePasswordTitle: 'Passwort ändern',
      currentPasswordLabel: 'Aktuelles Passwort',
      currentPasswordPlaceholder: 'Aktuelles Passwort eingeben',
      newPasswordLabel: 'Neues Passwort',
      newPasswordPlaceholder: 'Neues Passwort eingeben',
      confirmPasswordLabel: 'Neues Passwort bestätigen',
      confirmPasswordPlaceholder: 'Neues Passwort bestätigen',
      updatePasswordButton: 'Passwort aktualisieren',
      updatingButton: 'Aktualisiere...',
      currentDeviceLabel: 'Aktuelles Gerät',
      thisBrowserLabel: 'Dieser Browser',
      preferencesTitle: 'Einstellungen',
      themeLabel: 'Design',
      languageLabel: 'Sprache',
      notificationsTitle: 'Benachrichtigungen',
      savePreferencesButton: 'Einstellungen speichern',
      memberSinceLabel: 'Mitglied seit',
      lastLoginLabel: 'Letzte Anmeldung',
      sessionTitle: 'Sitzung',
      logoutDescription: 'Von Ihrer aktuellen Sitzung abmelden.',
      allFieldsRequired: 'Alle Felder sind erforderlich',
      passwordMinLengthError: 'Das Passwort muss mindestens 8 Zeichen lang sein',
      passwordsMismatchError: 'Passwörter stimmen nicht überein',
      profileTabLabel: 'Profil',
      securityTabLabel: 'Sicherheit',
      preferencesTabLabel: 'Einstellungen',
      infoTabLabel: 'Info',
      themeSystemDefault: 'Systemstandard',
      themeLightOption: 'Hell',
      themeDarkOption: 'Dunkel',
      languageEnglish: 'English',
      languageSpanish: 'Español',
      languageFrench: 'Français',
      languageGerman: 'Deutsch',
      languageItalian: 'Italiano',
      languageSlovenian: 'Slovenščina',
      temperatureUnitsLabel: 'Temperatureinheiten',
      celsiusOption: 'Celsius (°C)',
      fahrenheitOption: 'Fahrenheit (°F)',
      notificationGroupAlerts: 'Warnungen',
      notificationGroupAlertsDetail: 'Gerätewarnungen und Probleme des Hubs',
      notificationGroupAutomation: 'Automatisierung und Hinweise',
      notificationGroupAutomationDetail: 'Automatisierungen, Routinen, Timer und Erinnerungen',
      notificationGroupMessages: 'Anrufe und Nachrichten',
      notificationGroupMessagesDetail: 'Anrufe und Chat-Nachrichten',
      notificationGroupPartly: 'Teilweise an',
      notificationGroupsUnavailable: 'Ihre Benachrichtigungseinstellungen konnten nicht geladen werden.',
      userNotifications: {
        typeDeviceAlert: 'Gerätewarnungen',
        typeSystem: 'Probleme des Hubs',
        typeAutomation: 'Automatisierungen',
        typeRoutine: 'Routinen',
        typeInfo: 'Hinweise',
        typeCall: 'Anrufe',
        typeChat: 'Chat-Nachrichten',
        channelPush: 'Push',
        channelInApp: 'In der App',
        unavailable: 'Die Benachrichtigungseinstellungen dieser Person konnten nicht geladen werden.',
      },
      accountInformationTitle: 'Kontoinformationen',
      logOutButton: 'Abmelden',
      loggingOutButton: 'Abmeldung läuft...',
      notSetLabel: 'Nicht festgelegt',
      roleLabel: 'Rolle',
      userRoleDefault: 'Benutzer',
      activeLabel: 'Aktiv',
      otherSessionsHint: 'Andere aktive Sitzungen erscheinen hier',
    },

    // Notifications view
    notifications: {
      title: 'Benachrichtigungen',
      markAllAsRead: 'Alle als gelesen markieren',
      clearAll: 'Alle löschen',
      tabAll: 'Alle Benachrichtigungen',
      tabUnread: 'Ungelesen',
      tabByType: 'Nach Typ',
      loading: 'Lade Benachrichtigungen...',
      emptyState: 'Noch keine Benachrichtigungen',
      emptyUnread: 'Alles erledigt! Keine ungelesenen Benachrichtigungen',
      noNotificationsOfType: 'Keine Benachrichtigungen dieses Typs',
      markAsUnread: 'Als ungelesen markieren',
      markAsRead: 'Als gelesen markieren',
      deleteButton: 'Löschen',
      deleteAllConfirm: 'Alle Benachrichtigungen löschen?',
      timeJustNow: 'Gerade eben',
      timeMinutesAgo: 'Min.',
      timeHoursAgo: 'Std.',
      timeDaysAgo: 'T.',
    },

    // Alarms view
    alarms: {
      title: 'Alarme',
      newAlarm: 'Neuer Alarm',
      emptyState: 'Noch keine Alarme. Tippen Sie auf "Neuer Alarm", um zu beginnen.',
      editAlarmTitle: 'Alarm bearbeiten',
      labelField: 'Bezeichnung',
      labelPlaceholder: 'Aufwachen',
      timeField: 'Uhrzeit',
      repeatField: 'Wiederholung',
      noDaysHelp: 'Keine Tage ausgewählt = einmaliger Alarm',
      snoozeField: 'Schlummerdauer (Minuten)',
      soundField: 'Klang',
      cancel: 'Abbrechen',
      saveAlarm: 'Alarm speichern',
      saving: 'Speichere...',
      confirmDelete: 'Diesen Alarm löschen?',
      daysSu: 'So',
      daysMo: 'Mo',
      daysTu: 'Di',
      daysWe: 'Mi',
      daysTh: 'Do',
      daysFr: 'Fr',
      daysSa: 'Sa',
    },

    // People view
    people: {
      title: 'Personen',
      searchPlaceholder: 'Unterhaltungen durchsuchen...',
      loading: 'Laden...',
      emptyPeople: 'Keine Personen gefunden',
      selfDMDescription: 'Nachrichten, Dateien & Links speichern',
      selfBadge: 'Ich',
      selfConversationHint: 'Nur Sie können dies sehen',
      participantsLabel: 'Teilnehmer',
      audioCallTitle: 'Audioanruf',
      videoCallTitle: 'Videoanruf',
      moreOptionsTitle: 'Weitere Optionen',
      deleteAllMessages: 'Alle Nachrichten löschen',
      captionPlaceholder: 'Bildunterschrift hinzufügen (optional)...',
      messagePlaceholder: 'Nachricht eingeben...',
      someoneTyping: 'Jemand tippt...',
    },

    // Areas view

    // Integrations view
    integrations: {
      title: 'Integrationen',
      addIntegration: 'Integration hinzufügen',
      loading: 'Lade Integrationen...',
      emptyTitle: 'Keine Integrationen',
      emptyMessage: 'Fügen Sie eine neue Integration hinzu, um zu beginnen.',
      delete: 'Löschen',
      deleteTitle: 'Integration löschen',
      confirmDeletePrefix: 'Sind Sie sicher, dass Sie löschen möchten?',
      confirmDeleteSuffix: '? Dies wird auch alle zugehörigen Geräte entfernen.',
      cancel: 'Abbrechen',
      deleting: 'Lösche...',
      statusDisabled: 'Deaktiviert',
      statusConnected: 'Verbunden',
      statusDisconnected: 'Getrennt',
      statusDemo: 'Demo',
      demoMode: 'Demo-Modus',
      demoModeOn: 'Demo an',
      demoModeSaving: 'Speichere...',
      demoModeTooltip:
        'Demo-Modus: Diese Integration ist vom echten Gerät getrennt und liefert simulierte Werte. Ausschalten, um wieder echt zu verbinden.',
      demoModeHint: 'Diese Integration simulieren — kein Datenverkehr zum echten Gerät oder Bus.',
      demoModeActiveHint: 'Läuft mit simulierten Werten (Demo-Treiber). Es wird keine Hardware angesprochen.',
    },

    // Agent view
    agent: {
      title: `${brand.agentName}`,
      subtitle: 'Sprach- & Textassistent',
      reset: 'Zurücksetzen',
      resetTitle: 'Zurücksetzen, wenn der Agent hängt',
      clearButton: 'Löschen',
      history: 'Verlauf',
      emptyTitle: 'Wie kann ich helfen?',
      emptyMessage:
        'Versuchen Sie, mich zu bitten, Geräte zu steuern, den Status zu überprüfen oder Ihr Zuhause zu verwalten',
      thinking: 'Denke...',
      stop: 'Stopp',
      listeningIndicator: '🎤 Hört zu... Sprechen Sie jetzt',
      placeholder: 'Nachricht eingeben oder Sprache verwenden...',
      noHistory: 'Noch kein Unterhaltungsverlauf',
      suggestionLights: 'Schalte das Wohnzimmerlicht ein',
      suggestionTemperature: 'Wie ist die Temperatur?',
      suggestionCameras: 'Zeige mir die Kameras',
      suggestionScene: 'Führe Gute-Nacht-Szene aus',
    },

    // Room view
    room: {
      floorLabel: 'Stockwerk',
      addDevice: 'Gerät hinzufügen',
      editRoom: 'Raum bearbeiten',
      moreActions: 'Weitere Aktionen',
      emptyTitle: 'Keine Geräte in diesem Raum',
      emptyMessage: 'Klicken Sie auf "Gerät hinzufügen", um eines zu diesem Raum hinzuzufügen.',
      scenesSection: 'Szenen',
      chartsSection: 'Diagramme',
      deleteTitle: 'Gerät löschen',
      confirmDeletePrefix: 'Sind Sie sicher, dass Sie löschen möchten?',
      confirmDeleteSuffix: '',
      cancel: 'Abbrechen',
      deleting: 'Lösche...',
      devicesSection: 'Geräte',
      editLayout: 'Layout bearbeiten',
      done: 'Fertig',
      editHint:
        'Ziehen Sie Geräte zum Neuanordnen. Verwenden Sie die Symbolleiste jedes Geräts, um die Anzeige zu wählen.',
      dragToReorder: 'Zum Neuanordnen ziehen',
      deviceSettings: 'Geräteeinstellungen',
      displayAuto: 'Auto',
      displayButton: 'Schaltfläche',
      displayFull: 'Volle Breite',
      displayIcon: 'Symbol',
      addScene: 'Szene hinzufügen',
      reorderScenes: 'Szenen neu anordnen',
      reorder: 'Neu anordnen',
      dragScenesToReorder: 'Szenen zum Neuordnen ziehen',
      layout: 'Layout',
      layoutImageAlt: '{room} Layout',
      dragHandle: 'ziehen',
      otherType: 'Andere',
    },

    dashboardNew: {
      actionsMenuTitle: 'Dashboard-Aktionen',
      addDashboardAction: 'Dashboard hinzufügen',
      addWidgetAction: 'Widget hinzufügen',
      editDashboardAction: 'Dashboard bearbeiten',
      toggleEditModeAction: 'Bearbeitungsmodus umschalten',
      gridSettingsAction: 'Rastereinstellungen',
      loadingMessage: 'Lade Dashboard...',
      retryButton: 'Wiederholen',
      defaultDashboardName: 'Dashboard',
      welcomeHeading: `Willkommen bei ${brand.platformCompact}`,
      welcomeDescription: 'Erstellen Sie Ihr erstes Dashboard aus einer Vorlage oder von Grund auf.',
      createDashboardButton: 'Dashboard erstellen',
    },

    // Settings views
    settingsSystem: {
      title: 'Systemeinstellungen',
      systemName: 'Systemname',
      systemNamePlaceholder: `${brand.platformCompact}`,
      systemImage: 'Systembild',
      changeImage: 'Bild ändern',
      uploadImage: 'Bild hochladen',
      removeImage: 'Entfernen',
      imageSizeLimit: 'PNG, JPG oder WebP (max. 5MB)',
      imageTooLarge: 'Bilddatei ist zu groß (max. 10MB)',
      imageUploaded: 'Bild erfolgreich hochgeladen',
      imageRemoved: 'Bild erfolgreich entfernt',
      saveSystemSettings: 'Systemeinstellungen speichern',
      savingSystem: 'Speichere...',
      cloudServices: 'Cloud-Dienste',
      connected: 'Verbunden',
      disconnected: 'Getrennt',
      connecting: 'Verbinde...',
      connectionError: 'Verbindungsfehler',
      notRegistered: 'Nicht registriert',
      registerCloudDescription:
        'Registrieren Sie Ihren Hub bei Cloud-Diensten, um Remote-Zugriff und Freigabe zu ermöglichen.',
      cloudAccount: 'Cloud-Konto',
      cloudAccountEmail: 'Cloud-Konto-E-Mail',
      emailPlaceholder: "email{'@'}example.com",
      cloudUrl: 'Cloud-URL',
      registerWithCloud: 'In der Cloud registrieren',
      registering: 'Registriere...',
      reconnect: 'Neu verbinden',
      reconnecting: 'Verbinde neu...',
      unregister: 'Registrierung aufheben',
      unregistering: 'Hebe Registrierung auf...',
      sharedWith: 'Geteilt mit',
      hubNotShared: 'Dieser Hub wird mit niemandem geteilt.',
      removeAccess: 'Entfernen',
      viewOnly: 'Nur anzeigen',
      control: 'Steuerung',
      admin: 'Administrator',
      emailToSharePlaceholder: "benutzer{'@'}example.com",
      add: 'Hinzufügen',
      adding: 'Wird hinzugefügt...',
      loading: 'Lade...',
      saving: 'Speichere...',
      settingsSaved: 'Einstellungen erfolgreich gespeichert',
      hubLocation: 'Hub-Position',
      locationDescription:
        'Die Hub-Position wird für Wettervorhersagen und Sonnenaufgangs-/Sonnenuntergangsberechnungen verwendet.',
      automaticLocation: 'Automatisch',
      manual: 'Manuell',
      pickLocation: 'Position auf Karte auswählen',
      latitude: 'Breitengrad',
      latitudePlaceholder: 'z. B. 46.1199',
      longitude: 'Längengrad',
      longitudePlaceholder: 'z. B. 14.4992',
      elevation: 'Höhe (Meter)',
      elevationPlaceholder: 'z. B. 500',
      location: 'Position',
      saveHubLocation: 'Hub-Position speichern',
      weather: 'Wetter',
      weatherLocation: 'Wetterposition',
      searchCityPlaceholder: 'Stadtnamen eingeben',
      units: 'Einheiten',
      metric: 'Metrisch (°C, m/s)',
      imperial: 'Angloamerikanisch (°F, mph)',
      saveWeatherSettings: 'Wettereinstellungen speichern',
      cityRequired: 'Stadt ist erforderlich',
      weatherSettingsSaved: 'Wettereinstellungen gespeichert',
      citySearchFailed: 'Stadtsuche fehlgeschlagen',
      searchCity: 'Stadt suchen',
      enterCityName: 'Stadtnamen eingeben',
      searching: 'Suchen läuft...',
      search: 'Suchen',
      noCitiesFound: 'Keine Städte gefunden',
      enterCitySearch: 'Geben Sie mindestens 2 Zeichen zum Suchen ein',
      close: 'Schließen',
      checkForUpdates: 'Nach Updates suchen',
      checking: 'Suche...',
      confirmInstall: 'Update installieren? Das System wird neu gestartet.',
      confirmRollback: 'Zurückrollen? Das System wird neu gestartet.',
      installUpdate: 'Update installieren',
      installing: 'Installiere...',
      systemUpdates: 'Systemaktualisierungen',
      securityUpdateTooltip: 'Sicherheitsupdate',
      currentVersionLabel: 'Aktuelle Version',
      channelLabel: 'Kanal',
      lastCheckedLabel: 'Zuletzt geprüft',
      updateAvailableLabel: 'Aktualisierung verfügbar',
      lastUpdatedLabel: 'Zuletzt aktualisiert',
      kernelLabel: 'Kernel',
      checkingForUpdates: 'Suche nach Aktualisierungen...',
      applianceUpdateHint: 'Klicken Sie auf Nach Aktualisierungen suchen, um nach neuen Appliance-Releases zu suchen.',
      platformdUpToDate: 'Der Plattform-Daemon ist aktuell.',
      platformdNoUpdate: 'Keine Aktualisierung für den Plattform-Daemon verfügbar.',
      platformdUpdateHint: 'Klicken Sie auf Nach Aktualisierungen suchen, um nach Plattform-Daemon-Releases zu suchen.',
      systemUpdatesDisabled: 'Systemaktualisierungen sind auf diesem Gerät nicht aktiviert.',
      platformdUpdate: 'Plattform-Daemon',
      platformdUpdateDescription: 'Systemdienst, der Netzwerk, Hardware und Appliance-Updates verwaltet',
      installPlatformd: 'Plattform-Daemon aktualisieren',
      confirmInstallPlatformd: 'Plattform-Daemon aktualisieren? Der Dienst wird kurz neu gestartet.',
      platformdUpdateInProgress:
        'Aktualisierung des Plattform-Daemons läuft — der Dienst wird nach Abschluss neu gestartet.',
      licence: 'Lizenz',
      manageLicence: 'Lizenz verwalten',
      noPlan: 'Kein Tarif',
      unlimitedSeats: 'Unbegrenzte Arbeitsplätze',
      oneSeat: '1 Arbeitsplatz',
      seats: 'Arbeitsplätze',
      ownerOnly: 'Nur Eigentümer',
      accessLocalOnly: 'Nur lokaler Zugriff',
      accessRemote: 'Fernzugriff',
      licensedApps: 'Apps',
      licenceNeedsRegistration: 'Registrieren Sie diesen Server oben, um seine Lizenz aus der Cloud zu erhalten.',
      licencePending:
        'Warten darauf, dass die Cloud die Lizenz dieses Servers bestätigt — dies aktualisiert sich innerhalb einer Minute von selbst.',
      licenceStale: 'Nicht kürzlich bestätigt',
      licenceStaleHint: 'Die Cloud hat diese Lizenz seit einer Weile nicht bestätigt — prüfen Sie die Verbindung oben.',
      licenceGrantedTo: 'Erteilt an',
      licenceConfirmed: 'Zuletzt von der Cloud bestätigt',
      justNow: 'gerade eben',
      minutesAgo: 'Minuten her',
      hourAgo: 'Stunde her',
      hoursAgo: 'Stunden her',
      systemIcon: 'Systemsymbol',
      systemIconType: 'Symboltyp',
      systemIconGenerated: 'Automatisch erzeugt',
      systemIconCustom: 'Eigenes Bild',
      systemIconColor: 'Hintergrundfarbe',
      systemIconTextColor: 'Textfarbe',
      systemIconUpload: 'Symbol hochladen',
      systemIconPreview: 'Vorschau',
      systemIconSizeLimit: 'Nur PNG (max. 500KB)',
      systemIconSaved: 'Systemsymbol-Einstellungen gespeichert',
      saveSystemIconSettings: 'Systemsymbol-Einstellungen speichern',
      systemIconReset: 'Auf Standard zurücksetzen',
      systemIconResetConfirm: 'Systemsymbol auf Standard zurücksetzen?',
      systemIconResetDone: 'Systemsymbol auf Standard zurückgesetzt',
      applianceUpdate: 'Appliance-Update',
      applianceUpdateDescription: `${brand.agentName} Hub-Software- und Systempaket-Aktualisierungen`,
      confirmInstallSystem:
        'Alle Systempaket-Aktualisierungen installieren? Dies kann mehrere Minuten dauern. Das System läuft weiter.',
      installAll: 'Alle Aktualisierungen installieren',
      rollback: 'Auf vorherige Version zurücksetzen',
      rollingBack: 'Setze zurück...',
      upToDate: 'System ist aktuell',
      updateInProgress: 'Aktualisierung läuft — der Hub wird nach Abschluss neu gestartet.',
      updateCheckFailed: 'Suche nach Appliance-Updates fehlgeschlagen.',
      updateStatusInProgress: 'Ein Update läuft derzeit.',
      updateInstalling: 'Das Update wird installiert — der Hub startet neu, sobald es fertig ist.',
      updateStatusInstalling: 'Das Update wird installiert — der Hub startet neu, sobald es fertig ist.',
      updateStatusNotRegistered:
        'Bevor dieser Hub nach Appliance-Releases suchen kann, ist eine Cloud-Registrierung erforderlich.',
      updateStatusBlocked:
        'Dieser Hub benötigt ein Zwischen-Update, bevor er das neueste Appliance-Release installieren kann.',
      updateStatusNoRelease: 'Für diesen Kanal ist derzeit kein veröffentlichtes Appliance-Release verfügbar.',
      updateStatusUpToDate: 'Dieser Hub verwendet bereits das neueste veröffentlichte Appliance-Release.',
      updateStatusUnreachable: 'Der Update-Dienst war nicht erreichbar.',
      updateStatusNoUpdate: 'Derzeit ist kein Appliance-Update verfügbar.',
      updateStarted: 'Update gestartet. Der Hub startet neu, wenn ein neues Appliance-Release installiert wird.',
      updateStartFailed: 'Appliance-Update konnte nicht gestartet werden.',
      rollbackInitiated: 'Rollback eingeleitet. Der Hub startet neu, wenn ein Rollback-Image verfügbar ist.',
      rollbackStartFailed: 'Rollback konnte nicht gestartet werden.',
      systemUpdateCheckFailed: 'Systemupdates konnten nicht geprüft werden',
      systemInstallFailed: 'Installation fehlgeschlagen',
    },

    settingsUsers: {
      usersManagement: 'Personen und Geräte',
      peopleSectionTitle: 'Personen',
      peopleSectionHint:
        'Alle mit einer Rolle auf diesem Hub. Eine Person meldet sich mit ihrem Torik-Konto an — ein lokales Passwort gibt es nicht.',
      peopleEmpty: 'Auf diesem Hub ist noch niemand. Laden Sie die erste Person per E-Mail ein.',
      serverOwnerRow: 'Eigentümer dieses Servers',
      accountLinked: 'Verknüpft mit {email}',
      accountNotLinkedWithEmail: 'Noch kein Konto verknüpft — {email}',
      accountNotLinked: 'Noch kein Konto verknüpft',
      inviteDescription:
        'Senden Sie eine Einladung per E-Mail. Die Person nimmt sie an, während sie in ihrem Torik-Konto angemeldet ist — kein Passwort und kein Code.',
      inviteRoleHint: 'Sie erhalten auf diesem Hub die Rolle {role}.',
      addUser: 'Benutzer hinzufügen',
      usersLoading: 'Lade Benutzer...',
      done: 'Fertig',
      passwordNotAvailable:
        'Dieses Konto meldet sich mit seinem Torik-Konto oder einer Einladung an — ein lokales Passwort gibt es nicht.',
      editPersonTitle: 'Person bearbeiten',
      deviceListTitle: 'Verbundene Geräte',
      deviceLastSeen: 'Zuletzt gesehen {date}',
    },

    settingsBackup: {
      title: 'Sicherung & Wiederherstellung',
      automaticBackupSettings: 'Automatische Sicherungseinstellungen',
      createBackup: 'Sicherung erstellen',
      creatingBackup: 'Erstelle...',
      backupCreated: 'Sicherung erfolgreich erstellt',
      backupFailed: 'Sicherung konnte nicht erstellt werden',
      configurationOnlyInfo:
        'Diese Sicherungen enthalten nur die Konfiguration. Medien, Kameraaufnahmen, Kameraschnappschüsse und protokollierte Wertverläufe sind ausgeschlossen.',
      settingsSaved: 'Sicherungseinstellungen gespeichert',
      settingsLoadFailed: 'Sicherungseinstellungen konnten nicht geladen werden',
      settingsSaveFailed: 'Sicherungseinstellungen konnten nicht gespeichert werden',
      backupBeforeUpgrade: 'Vor Upgrade sichern',
      backupBeforeUpgradeDesc:
        'Vor der Installation eines Software-Updates wird automatisch eine Konfigurationssicherung erstellt.',
      weeklyEnabled: 'Wöchentliche Sicherungen aktivieren',
      weeklyEnabledDesc: 'Erstellt jede Woche eine Konfigurationssicherung gemäß dem unten stehenden Zeitplan.',
      weeklyDay: 'Sicherungstag',
      weeklyTime: 'Sicherungszeit',
      keepBackupsCount: 'Auf dem Server gespeicherte Sicherungen',
      keepBackupsCountHelp:
        'Ältere lokale Sicherungsdateien werden nach dem Erstellen neuer Sicherungen automatisch gelöscht.',
      destinationSettings: 'Sicherungsziele',
      networkCopyEnabled: 'Sicherung an Netzwerkpfad kopieren',
      networkCopyEnabledDesc:
        'Nach dem Erstellen der lokalen Serversicherung wird dieselbe Datei in einen Netzwerkordner oder eingebundenen Share kopiert.',
      networkBackupPath: 'Netzwerkpfad für Sicherungen',
      networkBackupPathPlaceholder: '\\\\nas\\otto\\backups oder /mnt/backups/otto',
      networkBackupPathHelp:
        'Verwenden Sie einen erreichbaren UNC-Pfad oder einen eingebundenen Ordner. Die lokale Server-Aufbewahrung gilt weiterhin nur für den Sicherungsordner des Servers.',
      cloudStorageTitle: 'Cloud-Speicher für Abonnenten',
      cloudStorageDesc: 'Der Cloud-Speicher für Abonnenten verwendet dasselbe Konfigurationssicherungspaket.',
      cloudStorageComingSoon:
        'Der Cloud-Upload ist noch nicht aktiv. Er wird aktiviert, sobald der Endpunkt für Abonnenten-Backups verfügbar ist.',
      localRetentionNote:
        'Manuelle Sicherungen verwenden dasselbe Konfigurationspaket und folgen derselben lokalen Aufbewahrungseinstellung.',
      availableBackups: 'Verfügbare Sicherungen',
      noBackups: 'Keine Sicherungen verfügbar',
      download: 'Herunterladen',
      delete: 'Löschen',
      deleteBackup: 'Sicherung löschen',
      confirmDeleteBackup: 'Sind Sie sicher, dass Sie diese Sicherung löschen möchten?',
      backupDeleted: 'Sicherung gelöscht',
      restoreFromBackup: 'Aus Sicherung wiederherstellen',
      warning:
        'Warnung: Die Wiederherstellung aus einer Sicherung überschreibt alle aktuellen Daten. Das System wird nach der Wiederherstellung neu gestartet.',
      selectBackupFile: 'Sicherungsdatei zur Wiederherstellung auswählen',
      restoringBackup: 'Stelle wieder her...',
      restoring: 'Stelle wieder her...',
      validating: 'Prüfe...',
      backupRestored: 'Sicherung erfolgreich wiederhergestellt',
      restoreFailed: 'Sicherung konnte nicht wiederhergestellt werden',
      confirmRestore: 'Dies überschreibt alle aktuellen Daten. Fortfahren?',
      confirmRestoreTitle: 'Wiederherstellung bestätigen',
      validationWarnings: 'Warnungen',
      backupInfo: 'Sicherungsinformationen',
      backupVersion: 'Version',
      backupDate: 'Datum',
      incompatibleWarning:
        'Das Datenbankschema ist nicht kompatibel. Die Wiederherstellung kann Fehler oder Datenverlust verursachen.',
      restoreInitiated: 'Die Wiederherstellung wurde gestartet. Das System wird in Kürze neu gestartet.',
      filename: 'Dateiname',
      created: 'Erstellt',
      fileSize: 'Dateigröße',
      downloadBackup: 'Sicherung herunterladen',
      selectFile: 'Datei auswählen',
      deleteConfirm: '{filename} löschen?',
      downloadFailed: 'Herunterladen fehlgeschlagen',
      acceptedFormats: '.otto_backup, .ottohome_backup, .1hub_backup',
      restoreWizardStep1: 'Sicherungsdatei auswählen',
      restoreWizardStep2: 'Sicherung prüfen',
      restoreWizardStep3: 'Wiederherstellungsoptionen',
      restoreWizardStep4: 'Wiederherstellung bestätigen',
      restoreWizardCrossServerBanner: 'Diese Sicherung stammt von einem anderen Server.',
      restoreWizardCrossServerInfo:
        'Benutzerpasswörter verwenden bcrypt und sind portierbar. Bestehende Benutzer können sich mit ihren Passwörtern anmelden. Der Server wird nach der Wiederherstellung neu gestartet - Sie müssen sich anschließend erneut anmelden.',
      restoreWizardCreateRecoveryAdmin: 'Wiederherstellungs-Admin erstellen',
      restoreWizardRecoveryUsername: 'Admin-Benutzername',
      restoreWizardRecoveryPassword: 'Admin-Passwort',
      restoreWizardRecoveryAdminDesc:
        'Stellt sicher, dass nach einer serverübergreifenden Wiederherstellung mindestens ein Admin-Konto funktioniert.',
      restoreWizardPreserveHubId: 'Aktuelle Server-Identität beibehalten',
      restoreWizardPreserveHubIdDesc: 'Verhindert das Überschreiben der eindeutigen ID dieses Servers (empfohlen).',
      restoreWizardSummaryDb: 'Die Datenbank wird durch den Inhalt der Sicherung ersetzt.',
      restoreWizardSummaryFiles: 'Uploads, Matter-Daten und Systembilder werden wiederhergestellt.',
      restoreWizardFinalWarning:
        'Der Server wird nach der Wiederherstellung neu gestartet. Alle verbundenen Benutzer werden getrennt.',
      restoreWizardUserCount: '{count} Benutzerkonten in der Sicherung',
      restoreWizardTableCount: '{count} Datenbanktabellen in der Sicherung',
      restoreWizardRestoreButton: 'Sicherung wiederherstellen',
      restoreWizardRestoring: 'Sicherung wird wiederhergestellt...',
      restoreWizardUploading: 'Sicherungsdatei wird hochgeladen...',
      restoreWizardRestoreComplete: 'Wiederherstellung abgeschlossen!',
      restoreWizardRestarting:
        'Das System wird neu gestartet. Sie werden in {seconds} Sekunden zur Anmeldeseite weitergeleitet...',
      restoreWizardContinue: 'Weiter',
      restoreWizardBack: 'Zurück',
      restoreWizardValidating: 'Sicherungsdatei wird geprüft...',
      restoreWizardValidationFailed: 'Die Sicherungsdatei konnte nicht geprüft werden.',
      valuesBackupTitle: 'Wertesicherung',
      valuesBackupDesc:
        'Sichert den Verlauf der Gerätewerte (Analogprotokolle, Zählerprotokolle, Wertprotokolle). Die Datei wird direkt heruntergeladen und nicht auf dem Server gespeichert.',
      exportValuesBackup: 'Wertesicherung exportieren',
      exportingValues: 'Wertesicherung wird exportiert...',
      valuesRestoreTitle: 'Werte wiederherstellen',
      valuesRestoreDesc: 'Stellen Sie den Werteverlauf aus einer früheren Wertesicherungsdatei wieder her.',
      valuesRestoreInfo:
        'Es werden nur Zeilen mit passenden Gerätewerten importiert. Werte von nicht vorhandenen Geräten werden übersprungen. Dies ist eine Zusammenführung - vorhandene Daten bleiben erhalten.',
      selectValuesBackup: 'Wertesicherungsdatei auswählen',
      importingValues: 'Wertesicherung wird importiert...',
      valuesRestoreResult: 'Werte wiederhergestellt: {inserted} eingefügt, {skipped} übersprungen',
      valuesRestoreFailed: 'Die Wiederherstellung der Wertesicherung ist fehlgeschlagen',
    },

    settingsAgent: {
      configuration: 'Konfiguration',
      voice: 'Sprache',
      enableAgent: 'Agent aktivieren',
      enableAgentDesc:
        'Aktivieren Sie den KI-Agenten, um Ihnen mit Sprachbefehlen und intelligenter Hausautomatisierung zu helfen.',
      wakeWord: 'Aktivierungswort',
      wakeWordDesc: `Wählen Sie das Sprachkommando, das den Agenten aktiviert (z. B. "Hey ${brand.agentName}", "OK Nabu").`,
      voiceDesc: 'Wählen Sie Ihre bevorzugte Stimme für die Antworten des Agenten.',
      autoListen: 'Automatisches Abhören',
      autoListenDesc:
        'Starten Sie das Abhören nach der Antwort des Agenten automatisch, um ein kontinuierliches Gespräch zu ermöglichen.',
      confirmActions: 'Aktionen bestätigen',
      confirmActionsDesc: 'Verlangen Sie eine Benutzerbestätigung, bevor Sie automatisierte Befehle ausführen.',
      settings: 'Einstellungen',
      saving: 'Speichern...',
      voiceServices: 'Sprachdienste',
      browserServices: 'Browser & Automatisierung',
    },

    settingsDevices: {
      searchDevices: 'Geräte durchsuchen...',
    },

    settingsDangerZone: {
      dangerZone: 'Gefahrenzone',
      deleteAllRooms: 'Alle Räume löschen',
      deleteAllRoomsDesc:
        'Löscht permanent alle Räume und ihre Konfigurationen. Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteAllDevices: 'Alle Geräte löschen',
      deleteAllDevicesDesc:
        'Löscht permanent alle Geräte und ihre Einstellungen. Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteAllIntegrations: 'Alle Integrationen löschen',
      deleteAllIntegrationsDesc:
        'Trennt und löscht alle Integrationen. Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteAllScenes: 'Alle Szenen löschen',
      deleteAllScenesDesc:
        'Löscht permanent alle Szenen und Automatisierungen. Diese Aktion kann nicht rückgängig gemacht werden.',
      factoryReset: 'Werksrücksetzung',
      warning: 'Warnung: Diese Aktion kann nicht rückgängig gemacht werden.',
      resetting: 'Wird zurückgesetzt...',
    },

    settingsLogs: {
      title: 'Systemprotokolle',
      logRetention: 'Protokollbereinigung',
      logRetentionDescription:
        'Alte Einträge aus Protokolltabellen automatisch löschen. Legen Sie fest, wie viele Tage die Daten aufbewahrt werden sollen.',
      valueLogsRetention: 'Wertprotokolle',
      scriptExecutionLogRetention: 'Skriptausführungsprotokoll',
      presenceEventsRetention: 'Anwesenheitsereignisse',
      intercomCallsRetention: 'Intercom-Anrufe',
      notificationsRetention: 'Benachrichtigungen',
      eventsRetention: 'Systemereignisse',
      sceneExecutionsRetention: 'Szenenausführungen',
      messagesRetention: 'Nachrichten',
      days: 'Tage',
      saveLogRetention: 'Bereinigungseinstellungen speichern',
      cleanNow: 'Jetzt bereinigen',
      cleaning: 'Bereinigung...',
      cleanNowConfirm: 'Sind Sie sicher? Alte Einträge werden endgültig gelöscht.',
      logRetentionSaved: 'Protokollbereinigungseinstellungen gespeichert',
      logCleanupDone: 'Bereinigung abgeschlossen: {count} Einträge gelöscht',
      saving: 'Speichere...',
    },

    settingsPlatform: {
      title: 'Plattform',
      storage: 'Speicher',
      dockerEngine: 'Engine',
      dockerCli: 'CLI',
      hardwareDescription: 'Hardware-Profil der Plattform und GPIO-Status',
      testHardware: 'Hardware testen',
      hardwareTest: 'Hardware-Test',
      hardwareTestDescription: 'System-LED steuern und Tastendrücke zum Testen simulieren.',
      ledCurrent: 'Aktueller LED-Zustand',
      cancel: 'Abbrechen',
      close: 'Schließen',
      timeConfiguration: 'Zeitsynchronisation',
      timezone: 'Zeitzone',
      loadingTimezones: 'Lade Zeitzonen...',
      ntpServers: 'NTP-Server',
      ntpPlaceholder: 'ntp.example.com, pool.ntp.org',
      ntpDescription: 'Kommagetrennte Liste von NTP-Servern. Leer lassen für Standard-Server.',
      saveTimeSettings: 'Zeiteinstellungen speichern',
      timeSettingsSaved: 'Zeiteinstellungen erfolgreich gespeichert',
      refresh: 'Aktualisieren',
      refreshing: 'Aktualisiere...',
      daemon: 'Plattform-Daemon',
      noUrlConfigured: 'Keine URL konfiguriert',
      version: 'Version',
      uptime: 'Laufzeit',
      profile: 'Profil',
      mode: 'Modus',
      mock: 'Simulation',
      hardwareMode: 'Hardware',
      hardware: 'Hardware',
      gpioConfigured: 'GPIO konfiguriert',
      mockGpio: 'Simuliertes GPIO',
      systemLed: 'System-LED',
      fan: 'Lüfter',
      capabilities: 'Funktionen',
      ledState: 'LED-Status',
      apply: 'Anwenden',
      applying: 'Wende an...',
      buttonPress: 'Tastendruck',
      buttonShort: 'Kurz',
      buttonMedium: 'Mittel',
      buttonLong: 'Lang',
      buttonVeryLong: 'Sehr lang',
      simulate: 'Simulieren',
      simulating: 'Simuliere...',
      host: 'Host',
      hostname: 'Hostname',
      runtime: 'Laufzeitumgebung',
      systemUptime: 'Systemlaufzeit',
      memory: 'Arbeitsspeicher',
      temperature: 'Temperature',
      loadAverage: 'Durchschnittslast',
      dockerServices: 'Docker-Dienste',
      available: 'Verfügbar',
      unavailable: 'Nicht verfügbar',
      restart: 'Neustarten',
      restarting: 'Starte neu...',
      noContainersReported: 'Keine Container gemeldet.',
      power: 'Stromversorgung',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      platform: 'Plattform',
      command: 'Befehl',
      requesting: 'Sende Anfrage...',
      reboot: 'Neu starten',
      shutdown: 'Herunterfahren',
      events: 'Ereignisse',
      noEventsReported: 'Keine Ereignisse gemeldet.',
      loadingStatus: 'Lade Status',
      notConfigured: 'Nicht konfiguriert',
      connected: 'Verbunden',
      disconnected: 'Getrennt',
      none: 'Keine',
      na: 'k. A.',
      noStatus: 'Kein Status',
      of: 'von',
      running: 'laufen',
      unknown: 'Unbekannt',
      ledBooting: 'Startet',
      ledHealthy: 'Gesund',
      ledDegraded: 'Eingeschränkt',
      ledOffline: 'Offline',
      ledUpdating: 'Aktualisiert',
      ledError: 'Fehler',
      ledFactoryResetPending: 'Werksreset ausstehend',
      ledUnknown: 'Unbekannt',
      confirmRestart: '{name} neu starten?',
      confirmReboot: 'Host neu starten?',
      confirmShutdown: 'Host herunterfahren?',
      se: {
        mode: 'Modus',
        type: 'Typ',
        notFound: 'Nicht gefunden',
        error: 'Fehler',
        title: 'Sicherheitselement',
        description: 'Hardware-Krypto-Coprozessor für die Matter-Zertifizierung',
        serial: 'Seriennummer',
        i2C: 'I²C-Bus',
        provisioned: 'Bereitgestellt',
        present: 'Vorhanden',
        yes: '✓ Ja',
        no: 'Noch nicht',
      },
      monitoring: {
        title: 'Systemüberwachung',
        description:
          'Konfigurieren Sie Warnungen für Schwellenwerte der Datenträgernutzung. Bei Erreichen der Grenzen werden Administratoren benachrichtigt.',
        alerts: 'Warnungen',
        diskWarning: 'Warnschwelle für Datenträger',
        diskCritical: 'Kritische Schwelle für Datenträger',
        save: 'Überwachungseinstellungen speichern',
        diskUsage: 'Datenträger',
        offlineNotice:
          'Der Plattform-Daemon ist offline — Schwellenwerte können lokale Ersatzwerte sein und lassen sich nicht speichern.',
      },
      network: {
        title: 'Netzwerk',
        description: 'Verwaltung von Netzwerkschnittstellen, WiFi und Hostname',
        hostname: 'Hostname',
        gateway: 'Standard-Gateway',
        gatewayShort: 'GW',
        dns: 'DNS-Server',
        backend: 'Backend',
        default: 'Standard',
        noInterfaces: 'Keine Schnittstellen gemeldet.',
        connectSsid: 'WiFi SSID',
        ssidPlaceholder: 'SSID suchen oder eingeben',
        password: 'Passwort',
        passwordPlaceholder: 'WiFi-Passwort',
        scan: 'Suchen',
        scanning: 'Suche...',
        connect: 'Verbinden',
        connecting: 'Verbinde...',
        saveHostname: 'Hostname speichern',
        resetDhcp: 'Kabelgebunden auf DHCP zurücksetzen',
        resetting: 'Setze zurück...',
        error: 'Fehler',
        confirmHostname:
          'Hostname auf {hostname} ändern? Dies kann den mDNS-Zugriff beeinträchtigen (z. B. {hostname}.local).',
        confirmResetDhcp: 'Die kabelgebundene Schnittstelle auf DHCP zurücksetzen? Dies kann die IP-Adresse ändern.',
        configure: 'Konfigurieren',
        static: 'Statische IP',
        dhcp: 'DHCP',
        methodLabel: 'Methode',
        ipConfig: 'IP-Konfiguration',
        ipAddress: 'IP-Adresse',
        prefix: 'Präfix',
        dnsDescription: 'Kommagetrennte DNS-Server.',
        dhcpDescription: 'Die Schnittstelle bezieht ihre IP-Adresse, das Gateway und DNS automatisch aus dem Netzwerk.',
        confirmStatic: '{iface} auf eine statische IP ({address}) setzen? Die Verbindung wird kurz unterbrochen.',
        confirmDhcp: '{iface} auf DHCP setzen? Die Verbindung wird kurz unterbrochen.',
        wifi: 'WiFi',
        wired: 'Kabelgebunden',
      },
      saving: 'Speichere...',
    },

    integrationCameras: {
      loadingState: 'Lade Kameras...',
      camerasTab: 'Kameras',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
      statusConnected: 'Verbunden',
      statusReady: 'Bereit',
      nvr: {
        serverSection: 'Diesen Hub freigeben (NVR-Server)',
        serverSectionHint: `Andere ${brand.platformCompact}-Hubs können sich hier verbinden und die Kameras ansehen, die Sie ihnen zuweisen.`,
        connectionInfo: 'Verbindungsinfo',
        hubUrl: 'Hub-URL (wird als Master-URL am anderen Hub verwendet)',
        newClient: 'Neuer Client',
        clientName: 'Client-Name',
        createClient: 'Erstellen',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
        clientsTitle: 'Clients (andere Hubs)',
        noClients: 'Noch keine Clients — erstellen Sie einen, um ein Einmal-Token zu erhalten.',
        tokenTitle: 'Einmal-Token für Client',
        tokenHint:
          'Fügen Sie dieses Token beim Hinzufügen einer NVR-Quelle in den anderen Hub ein. Es wird nur einmal angezeigt.',
        close: 'Schließen',
        assignedCameras: 'Zugewiesene Kameras',
        saveAssignment: 'Kameras speichern',
        lastSeen: 'Zuletzt gesehen',
        neverSeen: 'Nie verbunden',
        deleteClient: 'Löschen',
        remoteClient: 'Remote',
        sourceSection: 'Andere Hubs (NVR-Quellen)',
        sourceSectionHint:
          'Fügen Sie einen Hub hinzu, der Kameras mit Ihnen teilt, und importieren Sie dann seine Kameras. Importierte Kameras sind Thin Clients — die Aufnahme erfolgt auf dem Quell-Hub.',
        addSource: 'Quelle hinzufügen',
        sourceName: 'Name',
        masterUrl: 'Hub-URL',
        masterUrlHint:
          'Basis-URL des anderen Hubs, z. B. https://my-hub. Seine API ist unter /api erreichbar — sowohl https://my-hub als auch https://my-hub/api werden akzeptiert.',
        token: 'Token',
        test: 'Testen',
        testOk: 'Erreichbar',
        testFail: 'Fehlgeschlagen',
        showCameras: 'Kameras anzeigen',
        importSelected: 'Ausgewählte importieren',
        noRemoteCameras: 'Diesem Hub sind Ihnen noch keine Kameras zugewiesen.',
        remoteCamerasTitle: 'Kameras, die auf dem Quell-Hub verfügbar sind',
        importedTitle: 'Auf diesem Hub importiert',
        noImported: 'Noch keine Kameras importiert.',
        remove: 'Entfernen',
        removeAll: 'Alle entfernen',
        sync: 'Synchronisieren',
        adminRequired: 'Nur Administratoren können die NVR-Freigabe verwalten.',
        error: 'NVR-Freigabeeinstellungen konnten nicht geladen werden.',
      },
      nvrTab: 'NVR',
    },

    integrationDatapoints: {
      backButton: 'Zurück zu Integrationen',
      pageTitle: 'Datenpunkte',
      loadingState: 'Lade Datenpunkte...',
      statusConnected: 'Verbunden',
      statusDisconnected: 'Getrennt',
      errorMessage: 'Datenpunkte konnten nicht geladen werden',
    },

    integrationHomeAssistant: {
      entitiesTab: 'Entitäten',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
      loadingState: 'Lade Home Assistant-Daten...',
      errorMessage: 'Verbindung zu Home Assistant fehlgeschlagen',
    },
    settingsTorikApi: {
      cancel: 'Abbrechen',
      title: 'Torik API',
      subtitle: 'Home-Assistant-kompatible REST- + WebSocket-API für externe Tools und Hub-zu-Hub-Verknüpfungen.',
      refresh: 'Aktualisieren',
      running: 'API-Server läuft',
      stopped: 'API-Server gestoppt',
      port: 'Port',
      clients: 'Verbundene Clients',
      tokenCount: 'Aktive Token',
      enabled: 'Aktiviert',
      enabledToast: 'Torik-API aktiviert',
      disabledToast: 'Torik-API deaktiviert',
      endpoints: 'Endpunkte',
      authHint: `Authentifizierung mit "Authorization: Bearer ***" (WebSocket: {'{'}"type":"auth","access_token":"<token>"{'}'}).`,
      tokensTitle: 'Zugriffstoken',
      tokensHint: 'Langlebige Bearer-Token. Erstellen Sie hier eines und fügen Sie es in den verknüpfenden Hub ein.',
      newToken: 'Neues Token',
      noTokens: 'Noch keine API-Token.',
      lastUsed: 'zuletzt verwendet',
      never: 'nie',
      active: 'Aktiv',
      disabled: 'Deaktiviert',
      delete: 'Löschen',
      deleteConfirm: 'Dieses Token löschen? Clients, die es verwenden, verlieren sofort den Zugriff.',
      deleted: 'Token gelöscht',
      createTitle: 'API-Token erstellen',
      tokenCreatedTitle: 'Token erstellt',
      tokenName: 'Token-Name',
      tokenNamePlaceholder: 'z. B. Sekundärer Hub, Node-RED',
      creating: 'Erstelle...',
      create: 'Erstellen',
      copyWarning: 'Kopieren Sie dieses Token jetzt — es wird nur einmal angezeigt.',
      copy: 'Kopieren',
      copied: 'Token kopiert',
      copyFailed: 'Kopieren fehlgeschlagen',
      done: 'Fertig',
    },

    integrationKNX: {
      statusDisabled: 'Deaktiviert',
      statusConnected: 'Verbunden',
      statusDisconnected: 'Getrennt',
      deleteAllDevicesButton: 'Alle Geräte löschen',
      loadingState: 'Lade KNX-Daten...',
      settingsTab: 'Einstellungen',
      datapointsTab: 'Datenpunkte',
      devicesTab: 'Geräte',
      groupMonitorTab: 'Gruppenmonitor',
      logsTab: 'Protokolle',
      deleteModalTitle: 'Alle KNX-Geräte löschen',
      deleteConfirmMessage:
        'Sind Sie sicher, dass Sie alle KNX-Geräte löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteConfirmLabel: 'Zur Bestätigung geben Sie unten "DELETE" ein:',
      deleteConfirmPlaceholder: 'DELETE eingeben, um zu bestätigen',
      cancelButton: 'Abbrechen',
      deleteConfirmButton: 'Alle Geräte löschen',
      deletingState: 'Lösche Geräte...',
      errorMessage: 'KNX-Anfrage konnte nicht verarbeitet werden',
    },

    remoteSupport: {
      selectIntegration: 'KNX-Integration auswählen',
      selectIntegrationPlaceholder: 'KNX-Integration wählen...',
      knxRemoteSupport: 'KNX Fernunterstützung',
      tpuartTitle: 'TP-UART-Treiber erforderlich',
      tpuartDesc:
        'Die gemeinsame Nutzung der KNX-Schnittstelle über den TP-UART-Treiber wird verfügbar sein, sobald der Plattform-Daemon dies unterstützt.',
      remoteUsers: 'Fernunterstützungs-Benutzer',
      remoteUsersDesc:
        'Verwalten Sie Benutzer, die Fernunterstützung leisten können. Fügen Sie Benutzer per E-Mail hinzu und konfigurieren Sie Zugriffszeitlimits.',
      addUserByEmail: 'Benutzer per E-Mail hinzufügen',
      emailPlaceholder: "benutzer{'@'}beispiel.de",
      addUser: 'Hinzufügen',
      adding: 'Füge hinzu...',
      remove: 'Entfernen',
      removing: 'Entferne...',
      installerRole: 'Installateur',
      noEmail: 'Keine E-Mail',
      noRemoteUsers: 'Noch keine Fernunterstützungs-Benutzer.',
      editAccess: 'Bearbeiten',
      day: 'Tag',
      days: 'Tage',
      daysAccess: 'Tage Zugriff',
      perSession: 'pro Sitzung',
      unlimited: 'Unbegrenzt',
      unlimitedAccess: 'Unbegrenzter Zugriff',
      confirmRemoveUser:
        '{name} aus der Fernunterstützung entfernen? Das Konto wird in ein normales Benutzerkonto umgewandelt.',
      accessDaysPrompt: 'Zugriffsdauer (Tage, 0 = unbegrenzt):',
      accessHoursPrompt: 'Max. Stunden pro Sitzung:',
      newSession: 'Neue Fernunterstützungssitzung',
      selectUser: 'Benutzer auswählen',
      selectUserPlaceholder: 'Benutzer wählen...',
      timeWindow: 'Sitzungsdauer',
      createSession: 'Sitzung erstellen',
      creating: 'Erstelle...',
      endSession: 'Sitzung beenden',
      ending: 'Beende...',
      activeSessions: 'Aktive Sitzungen',
      installerLabel: 'Installateur',
      timeRemaining: 'Verbleibende Zeit',
      expired: 'Abgelaufen',
      justNow: 'gerade eben',
      ago: 'her',
      hour: 'Stunde',
      hours: 'Stunden',
      minutes: 'Minuten',
      send: 'Senden',
      messagePlaceholder: 'Nachricht eingeben...',
      noMessages: 'Noch keine Nachrichten.',
      issueReport: 'Problembericht / Chat',
      issueReportDesc: 'Nachricht an den Fernunterstützungs-Benutzer über das zu bearbeitende Problem.',
      viewChat: 'Chat',
      cannotAddSelf:
        'Sie können sich nicht selbst hinzufügen. Dadurch würden Sie sich aus Ihrem Admin-Konto aussperren.',
    },

    integrationMatter: {
      loadingState: 'Lade Matter-Daten...',
      settingsTab: 'Einstellungen',
      nodesTab: 'Knoten',
      devicesTab: 'Geräte',
      logsTab: 'Protokolle',
      errorMessage: 'Verbindung zum Matter-Netzwerk fehlgeschlagen',
    },

    integrationMatterBridge: {
      brideDeviceCount: 'Bridgede Geräte',
      loadingState: 'Lade Matter Bridge-Daten...',
      bridgedDevicesTab: 'Bridgede Geräte',
      commissioningTab: 'Inbetriebnahme',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
      errorMessage: 'Verbindung zur Matter Bridge fehlgeschlagen',
    },

    integrationComputers: {
      subtitle: `Computer mit dem ${brand.agentName}-Agent, verbunden mit diesem Hub.`,
      integrationLabel: `${brand.platformCompact}-Computer`,
      refreshAction: 'Aktualisieren',
      addComputerAction: 'Computer hinzufügen',
      totalLabel: 'Computer',
      onlineLabel: 'Online',
      offlineLabel: 'Offline',
      onlineState: 'Online',
      offlineState: 'Offline',
      connectedState: 'Verbunden',
      noComputersState: 'Aktiviert, keine Computer',
      disabledState: 'Deaktiviert',
      unknownState: 'Unbekannt',
      loadingState: 'Computer werden geladen…',
      emptyTitle: 'Noch keine Computer',
      emptyMessage: `Installieren Sie den ${brand.agentName}-Agent auf einem Computer und koppeln Sie ihn mit diesem Hub, um ihn von ${brand.platformName} aus zu steuern.`,
      hostLabel: 'Host',
      platformLabel: 'Plattform',
      agentVersionLabel: 'Agent',
      lastSeenLabel: 'Zuletzt gesehen',
      neverSeen: 'nie',
      memoryLabel: 'Speicher',
      diskLabel: 'Festplatte',
      tempLabel: 'CPU-Temperatur',
      uptimeLabel: 'Laufzeit',
      rebootAction: 'Neu starten',
      sleepAction: 'Ruhezustand',
      shutdownAction: 'Herunterfahren',
      wakeAction: 'Aufwecken',
      wakeSendAction: 'Weckpaket senden',
      wakeHint:
        'Der Hub sendet das Weckpaket aus seinem eigenen Netzwerk (WOL muss im BIOS des Computers aktiviert sein).',
      removeAction: 'Entfernen',
      refreshNodeAction: 'Status aktualisieren',
      macPlaceholder: 'AA:BB:CC:DD:EE:FF',
      loadError: 'Computer konnten nicht geladen werden',
      refreshFailed: 'Aktualisierung fehlgeschlagen',
      powerSent: 'Energiebefehl gesendet an',
      powerFailed: 'Energiebefehl fehlgeschlagen',
      wakeSent: 'Weckpaket gesendet',
      wakeFailed: 'Wake-on-LAN fehlgeschlagen',
      removeConfirmTitle: 'Computer entfernen?',
      removeConfirmMessage: 'Dadurch wird der Computer von diesem Hub getrennt und sein Gerät entfernt.',
      removed: 'Computer entfernt',
      removeFailed: 'Entfernen fehlgeschlagen',
      addDialogTitle: 'Computer hinzufügen',
      addDialogSubtitle: `Erzeugen Sie einen Kopplungscode und installieren Sie dann den ${brand.agentName}-Agent mit diesem Code auf dem Computer. Der Code läuft nach 15 Minuten ab.`,
      nodeNamePlaceholder: 'z. B. Studio-PC',
      generateTokenAction: 'Kopplungscode erzeugen',
      copyTokenAction: 'Kopieren',
      pairingCodeLabel: 'Kopplungscode',
      installCommandTitle: 'Führen Sie auf dem Computer aus:',
      doneAction: 'Fertig',
      copied: 'Kopplungscode kopiert',
      copyFailed: 'Kopieren fehlgeschlagen',
      pairingFailed: 'Kopplungscode konnte nicht erzeugt werden',
      macLabel: 'MAC',
      hubAddressLabel: 'Hub-Adresse',
      hubAddressHint:
        'Die Adresse, über die Computer diesen Hub erreichen. Die Liste zeigt die Netzwerkadressen dieses Hubs — wählen Sie die Adresse, die der Computer erreichen kann (z. B. dasselbe Netzwerk), oder geben Sie eine eigene Adresse ein. In der Produktion (https) ist die Hub-Adresse vorausgewählt.',
      commandCopied: 'Befehl kopiert',
      computersTab: 'Computer',
      devicesTab: 'Geräte',
      customHubAddressAction: 'Eigene Adresse...',
      customHubAddressPlaceholder: 'http://192.168.1.72',
      selectHubAddressHint: 'Wählen Sie oben eine Hub-Adresse, um die Installationsbefehle zu sehen.',
    },
    integrationTouchPanels: {
      integrationName: 'Touch Panels',
      statusDisabled: 'Deaktiviert',
      statusConnected: 'Verbunden',
      statusReady: 'Bereit',
      loadingState: 'Touch-Panel-Integration wird geladen...',
      panelsTab: 'Panels',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
      refreshAction: 'Aktualisieren',
      panelsAction: 'Panels',
      settingsAction: 'Einstellungen',
      logsAction: 'Protokolle',
      totalPanelsLabel: 'Registrierte Panels',
      onlinePanelsLabel: 'Online',
      offlinePanelsLabel: 'Offline',
      sleepingPanelsLabel: 'Schlafend',
      pairingStatusLabel: 'Kopplungsstatus',
      pairedPanelsLabel: 'Gekoppelt',
      pendingPanelsLabel: 'Ausstehende Kopplung',
      lastActivityLabel: 'Letzte Aktivität',
      noActivityLabel: 'Keine aktuelle Aktivität',
      noActivityDescription: 'Noch kein Panel hat Aktivität gemeldet',
      attentionLabel: 'Benötigt Aufmerksamkeit',
      justNowLabel: 'gerade eben',
      minutesAgoLabel: 'vor {count} Min.',
      hoursAgoLabel: 'vor {count} Std.',
      daysAgoLabel: 'vor {count} T.',
      errorMessage: 'Touch-Panel-Integration konnte nicht geladen werden',
    },

    integrationZigbee: {
      loadingState: 'Lade Zigbee-Daten...',
      nodesTab: 'Knoten',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      errorMessage: 'Verbindung zum Zigbee-Netzwerk fehlgeschlagen',
    },

    integrationZWave: {
      loadingState: 'Lade Z-Wave-Daten...',
      nodesTab: 'Knoten',
      networkTab: 'Netzwerk',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      errorMessage: 'Verbindung zum Z-Wave-Netzwerk fehlgeschlagen',
    },
    integrationWled: {
      segmentsTab: 'Segmente',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
      loadingState: 'Laden...',
      errorMessage: 'Integration konnte nicht geladen werden',
    },

    integrationHue: {
      lightsTab: 'Lichter',
      groupsTab: 'Gruppen',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
    },
    integrationUnifi: {
      networkTab: 'Netzwerk',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
    },
    integrationSomfy: {
      gatewayTab: 'Gateway',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
    },
    integrationSynology: {
      statusTab: 'Status',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
    },
    integrationMediaPlayers: {
      playersTab: 'Player',
      devicesTab: 'Geräte',
      sourcesTab: 'Quellen',
      settingsTab: 'Einstellungen',
    },
    integrationSonos: {
      settingsTab: 'Einstellungen',
      playersTab: 'Player',
      devicesTab: 'Geräte',
    },
    integrationSpotify: {
      settingsTab: 'Einstellungen',
      devicesTab: 'Geräte',
    },

    panelPairing: {
      title: `${brand.agentName} Touch-Panel`,
      subtitle: 'Geräteeinrichtung',
      discoverTitle: `Ihren ${brand.agentName} Hub finden`,
      discoverDescription: `Durchsuche Ihr lokales Netzwerk nach einem ${brand.agentName} Hub...`,
      scanningStatus: 'Scanne Netzwerk...',
      noHubsFound: 'Keine Hubs automatisch gefunden.',
      manualEntryHint: 'Geben Sie die Hub-Adresse manuell unten ein.',
      manualEntryLabel: 'Oder manuell eingeben',
      ipAddressPlaceholder: 'Hub-IP-Adresse',
      portPlaceholder: 'Port',
      connectButton: 'Verbinden',
      rescanButton: '↻ Erneut scannen',
      backButton: 'Zurück',
      connectedToLabel: 'Verbunden mit',
      pairingMethodTitle: 'Dieses Gerät koppeln',
      pairingRequirement: `Ein Administrator muss in der ${brand.agentName}-App einen Kopplungscode generieren.`,
      enterPinButton: 'PIN eingeben',
      pinEntryTitle: 'Kopplungs-PIN eingeben',
      pinEntryDescription: `Geben Sie die 6-stellige PIN ein, die in der ${brand.agentName}-Admin-App angezeigt wird.`,
      pairDeviceButton: 'Gerät koppeln',
      pairingInProgress: 'Koppele...',
      invalidPinError: 'Ungültige PIN. Bitte versuchen Sie es erneut.',
      cameraAccessDenied: 'Kamerazugriff verweigert. Bitte aktivieren Sie die Kameraberechtigungen.',
      invalidQrError: 'Ungültiger QR-Code. Bitte versuchen Sie es erneut.',
      exitPinTitle: 'Exit-PIN festlegen',
      exitPinDescription: 'Wählen Sie eine 4-stellige PIN, um später den Panel-Modus zu verlassen.',
      skipButton: 'Überspringen',
      pairedSuccess: 'Gerät gekoppelt!',
      connectingMessage: 'Verbinde mit Ihrem Panel...',
    },

    playPairing: {
      title: `${brand.agentName} Play`,
      subtitle: 'Geräteeinrichtung',
      discoverTitle: `Ihren ${brand.agentName} Hub finden`,
      discoverDescription: `Durchsuche Ihr lokales Netzwerk nach einem ${brand.agentName} Hub...`,
      scanningStatus: 'Scanne Netzwerk...',
      noHubsFound: 'Keine Hubs automatisch gefunden.',
      manualEntryHint: 'Geben Sie die Hub-Adresse manuell unten ein.',
      manualEntryLabel: 'Oder manuell eingeben',
      ipAddressPlaceholder: 'Hub-IP-Adresse',
      portPlaceholder: 'Port',
      connectButton: 'Verbinden',
      rescanButton: '↻ Erneut scannen',
      backButton: 'Zurück',
      connectedToLabel: 'Verbunden mit',
      pairingMethodTitle: 'Dieses Gerät koppeln',
      pairingRequirement: `Ein Administrator muss in der ${brand.agentName}-App einen Kopplungscode generieren.`,
      enterPinOption: 'PIN eingeben',
      enterPinDescription: 'Geben Sie den 6-stelligen Code ein, der in der Admin-App angezeigt wird',
      scanQrOption: 'QR-Code scannen',
      scanQrDescription: 'Scannen Sie den QR-Code, der in der Admin-App angezeigt wird',
      pinEntryTitle: 'Kopplungs-PIN eingeben',
      pinEntryDescription: `Geben Sie die 6-stellige PIN ein, die in der ${brand.agentName}-Admin-App angezeigt wird.`,
      pairDeviceButton: 'Gerät koppeln',
      pairingInProgress: 'Koppele...',
      scanQrTitle: 'QR-Code scannen',
      scanQrInstruction: `Richten Sie die Kamera auf den QR-Code in der ${brand.agentName}-Admin-App.`,
      scanningAutoStatus: 'Scanne automatisch...',
      exitPinTitle: 'Exit-PIN festlegen',
      exitPinDescription: 'Wählen Sie eine 4-stellige PIN, um später den Play-Modus zu verlassen.',
      confirmPinButton: 'PIN bestätigen',
      reenterPinInstruction: 'Geben Sie Ihre PIN erneut ein, um zu bestätigen',
      pinMismatchError: 'PINs stimmen nicht überein. Versuchen Sie es erneut.',
      skipButton: 'Überspringen',
      pairedSuccess: 'Gerät gekoppelt!',
      pairedDescription: `Dieses Gerät ist jetzt als Play-Gerät mit Ihrem ${brand.agentName}-Hub verbunden.`,
      startPlayModeButton: 'Play-Modus starten',
      invalidPinError: 'Ungültige PIN. Bitte versuchen Sie es erneut.',
      cameraAccessDenied: 'Kamerazugriff verweigert. Bitte aktivieren Sie die Kameraberechtigungen.',
      invalidQrError: 'Ungültiger QR-Code. Bitte versuchen Sie es erneut.',
    },

    gallery: {
      pageTitle: 'Fotos',
      emptyTitle: 'Noch keine Fotos',
      emptyDescription: 'Laden Sie Fotos und Videos hoch, um Ihre persönliche Cloud-Galerie zu starten.',
      noAlbumTitle: 'Noch keine Alben',
      noAlbumDescription: 'Erstellen Sie ein Album, um Ihre Fotos zu gruppieren und zu teilen.',
      noAlbumItems: 'Noch keine Fotos in diesem Album',
      newAlbum: 'Neues Album',
      takePhoto: 'Kamera',
      uploadPhotos: 'Hochladen',
      createAlbumTitle: 'Album erstellen',
      selectPhotos: 'Auswählen',
      uploadProgress: 'Hochladen',
      dropZoneText: 'Fotos & Videos hier ablegen',
      uploadStatus: 'Datei',
      uploadStatusPlural: 'Dateien',
      sharedBadge: 'Geteilt',
      publicBadge: 'Öffentlich',
    },

    reminders: {
      pageTitle: 'Erinnerungen',
      addButton: 'Neue Erinnerung',
      upcomingTab: 'Bevorstehend',
      completedTab: 'Abgeschlossen',
      emptyUpcoming: 'Keine bevorstehenden Erinnerungen.',
      emptyCompleted: 'Keine abgeschlossenen Erinnerungen.',
      createReminderTitle: 'Neue Erinnerung',
      editReminderTitle: 'Erinnerung bearbeiten',
      titleLabel: 'Titel',
      titlePlaceholder: 'Lebensmittel einkaufen',
      notesLabel: 'Notizen',
      notesPlaceholder: 'Zusätzliche Details...',
      notesOptional: '(optional)',
      dateTimeLabel: 'Datum & Uhrzeit',
      repeatLabel: 'Wiederholung',
      repeatNone: 'Keine',
      repeatDaily: 'Täglich',
      repeatWeekly: 'Wöchentlich',
      repeatMonthly: 'Monatlich',
      repeatWeekdays: 'Wochentage (Mo–Fr)',
      cancelButton: 'Abbrechen',
      saveButton: 'Speichern',
      createButton: 'Erinnerung erstellen',
    },

    timers: {
      pageTitle: 'Timer',
      addButton: 'Neuer Timer',
      emptyState: 'Noch keine Timer. Tippen Sie auf "Neuer Timer", um einen zu erstellen.',
      createTimerTitle: 'Neuer Timer',
      labelLabel: 'Bezeichnung',
      labelPlaceholder: 'Nudelwasser',
      durationLabel: 'Dauer',
      hoursLabel: 'Stunden',
      minutesLabel: 'Minuten',
      secondsLabel: 'Sekunden',
      soundLabel: 'Klang',
      totalLabel: 'Gesamt',
      startButton: 'Abspielen',
      pauseButton: 'Pause',
      resetButton: 'Zurücksetzen',
      deleteButton: 'Löschen',
      deleteConfirm: 'Diesen Timer löschen?',
      cancelButton: 'Abbrechen',
      createButton: 'Erstellen',
      creatingLabel: 'Erstelle...',
      statusIdle: 'inaktiv',
      statusRunning: 'läuft',
      statusPaused: 'pausiert',
      statusCompleted: 'abgeschlossen',
    },
    integrationESPHome: {
      entitiesTab: 'Knoten & Entitäten',
      devicesTab: 'Geräte',
      settingsTab: 'Einstellungen',
      logsTab: 'Protokolle',
      loadingState: 'Lade ESPHome-Daten...',
      errorMessage: 'ESPHome-Integration konnte nicht geladen werden',
    },
    integrationTorik: {
      entitiesTab: 'Import',
      devicesTab: 'Geräte',
      settingsTab: 'Verknüpfung',
      logsTab: 'Protokolle',
      loadingState: 'Lade Torik-Hub-Verknüpfung...',
      entitiesTitle: 'Remote-Geräte',
      entitiesHint:
        'Geräte am verknüpften Hub suchen und als lokale Geräte importieren. Werte bleiben synchron, Befehle werden weitergeleitet.',
      discover: 'Geräte suchen',
      discovering: 'Suche Geräte...',
      searchPlaceholder: 'Nach Name oder Entitäts-ID suchen...',
      selectAll: 'Alle auswählen',
      selected: 'ausgewählt',
      importCount: 'Importieren',
      imported: 'Importiert',
      emptyState: 'Drücken Sie Geräte suchen, um Geräte vom verknüpften Hub zu laden.',
      importTitle: 'Remote-Geräte importieren',
      roomMapping: 'Remote-Räume lokalen Räumen zuordnen:',
      remoteRoom: 'Remote-Raum:',
      noRoom: '— Kein Raum (automatische Zuordnung nach Name) —',
      created: 'Erstellt',
      skipped: 'Übersprungen',
      errors: 'Fehler',
      close: 'Schließen',
      cancel: 'Abbrechen',
      import: 'Importieren',
      importing: 'Importiere...',
      linkTitle: 'Hub-Verknüpfung',
      linkHint: 'Verbindung zum verknüpften Torik-Hub (seine Torik-API).',
      test: 'Verbindung testen',
      testing: 'Teste...',
      sync: 'Jetzt synchronisieren',
      syncing: 'Synchronisiere...',
      syncDone: 'Synchronisierung abgeschlossen',
      reconnect: 'Neu verbinden',
      reconnecting: 'Verbinde neu...',
      reconnectDone: 'Neu verbunden',
      cleanup: 'Alle importierten Geräte entfernen',
      cleaning: 'Entferne...',
      cleanupConfirm: 'Alle von diesem Hub importierten Geräte entfernen? Dies kann nicht rückgängig gemacht werden.',
      cleanupDone: 'Entfernte Geräte',
      peerUrl: 'Peer-URL',
      peerVersion: 'Peer-Version',
      token: 'Zugriffstoken',
    },
    // The guest experience of the demo house (card `t_803e86a4`) — see `en.ts`.
    demoGuest: {
      pill: 'Gast',
      pillNamed: 'Gast · {name}',
      hint: 'Dies ist ein Demo-Haus — ein ganzer Tag vergeht in Minuten.',
      dismiss: 'Ausblenden',
    },
  },
  shell: {
    home: 'Startseite',
    // The floor for a tab nothing else names (card t_99f5ed79) — see `en.ts`.
    newTab: 'Neuer Tab',
    closeTab: 'Tab schließen',
    alertError: 'Fehler',
    alertWarning: 'Warnung',
    alertNotice: 'Hinweis',
    player: 'Player',
    previous: 'Zurück',
    play: 'Wiedergabe',
    pause: 'Pause',
    mute: 'Stumm',
    unmute: 'Ton an',
    volume: 'Lautstärke',
    // The main process's native popups (card t_99f5ed79): the tab context menu,
    // the app menu, and the connection-info dialog — see `en.ts` for the note.
    openInNewWindow: 'In neuem Fenster öffnen',
    connectionInfo: 'Verbindungsinformationen',
    reload: 'Neu laden',
    fullscreen: 'Vollbild',
    close: 'Schließen',
    launcher: 'Launcher',
    services: 'Dienste',
    miniPlayerWindow: 'Mini-Player-Fenster',
    rebuildBar: 'Systemleiste neu aufbauen',
    settings: 'Einstellungen',
    quit: 'Beenden',
    info: {
      target: 'Ziel',
      endpoint: 'Endpunkt',
      hubId: 'Hub-ID',
      hubName: 'Hub-Name',
      state: 'Status',
      route: 'Route',
      connected: 'verbunden',
      disconnected: 'getrennt',
      secure: 'sicher',
      cloudHub: 'Cloud-Hub {id}',
      managedInLauncher: 'Zugangsdaten und gespeicherte Server werden im Launcher verwaltet.',
      ok: 'OK',
      tab: 'Tab',
    },
  },
  connectionLost: {
    title: 'Verbindung verloren',
    session:
      '{hub}: Ihre Sitzung ist abgelaufen. Stellen Sie die Verbindung wieder her, um in diesem Tab weiterzuarbeiten.',
    offline: '{hub} antwortet nicht. Prüfen Sie das Netzwerk und verbinden Sie sich dann neu.',
    thisServer: 'Dieser Server',
    reconnect: 'Neu verbinden',
    reconnecting: 'Neuverbindung...',
    close: 'Schließen',
  },
  api: {
    // What a failed hub call actually means (`utils/apiFailure.ts`), so a surface
    // that only catches the error can still name the cause instead of one sentence
    // that fits every failure — read as `t(apiFailureSentenceKey(error))`.
    failure: {
      unreachable: 'Das Hub war nicht erreichbar, daher konnten diese Einstellungen nicht gelesen werden.',
      refused: 'Dieses Fenster ist nicht beim Hub angemeldet, daher hat es diese Einstellungen abgelehnt.',
      wrong_target:
        'Die Antwort kam nicht vom Dienst dieses Hubs, daher konnten diese Einstellungen nicht gelesen werden.',
      hub_failed: 'Das Hub meldete beim Lesen dieser Einstellungen einen Fehler.',
    },
  },
  hub: {
    // Adopting an unclaimed hub from the app (HEADLESS-HUB-ONBOARDING.md
    // D3/D4/D5): the confirm sheet, the sticker QR and every refusal the hub
    // can answer with — one sentence each, in every shipped locale.
    adopt: {
      title: 'Diesen Hub übernehmen',
      intro:
        'Dieser Hub ist in Ihrem Netzwerk und hat noch keinen Besitzer. Beim Übernehmen wird er unter Ihrem Torik-Konto registriert und Sie werden sein Besitzer.',
      notOffered:
        'Dieser Hub wartet nicht auf eine Übernahme, hier gibt es also nichts zu übernehmen. Es wurde nichts gesendet — wenn Ihr Torik-Konto auf diesem Hub liegt, öffnen Sie ihn über Ihre Server.',
      hubLabel: 'Hub',
      accountLabel: 'Konto',
      roleLabel: 'Ihre Rolle',
      roleOwner: 'Besitzer',
      noCode: 'Nichts einzugeben — Ihr Konto ist die Berechtigung.',
      noAccount: 'Nicht angemeldet',
      // Eine Sitzung, deren Konto dieses Blatt nicht kennt: das Gerät IST
      // angemeldet — die Zeile darf nichts anderes behaupten (Karte t_a53c5f61).
      accountSignedIn: 'Angemeldet',
      signInRequired: 'Melden Sie sich bei Ihrem Torik-Konto an, um diesen Hub zu übernehmen.',
      signIn: 'Anmelden',
      signingIn: 'Wird geöffnet …',
      signInFailed: 'Die Anmeldung konnte nicht gestartet werden. Versuchen Sie es erneut.',
      confirm: 'Diesen Hub übernehmen',
      working: 'Wird übernommen …',
      retry: 'Erneut versuchen',
      cancel: 'Abbrechen',
      doneTitle: '{hub} gehört Ihnen',
      doneBody: 'Er ist unter {account} registriert, und dieses Gerät ist jetzt damit verbunden.',
      // Die Variante des obigen Satzes ohne Kontonamen: `{account}` kann in
      // nicht jeder Sprache eine Wendung tragen, daher formuliert dieser Fall selbst.
      doneBodySignedIn: 'Er ist unter Ihrem Torik-Konto registriert, und dieses Gerät ist jetzt damit verbunden.',
      doneWhere: 'Sie finden ihn in Ihren Servern, auf der Startseite.',
      roleLine: 'Sie haben die Rolle {role} auf diesem Hub.',
      continue: 'Weiter',
      scanLead: 'Ganz neuer Hub? Scannen Sie den Code auf der Verpackung — damit übernehmen Sie ihn in Ihr Konto.',
      linkWrongHub:
        'Dieser Code gehört zu einem anderen Hub als dem, der unter dieser Adresse antwortet. Es wurde nichts übernommen.',
      linkUnverified:
        'Der Hub unter dieser Adresse hat nicht bestätigt, welcher Hub er ist, daher wurde nichts übernommen. Prüfen Sie, ob der Hub eingeschaltet und erreichbar ist.',
      rateLimited: 'Zu viele Versuche von diesem Gerät. Warten Sie eine Minute und versuchen Sie es erneut.',
      notOnHubNetwork:
        'Der Hub hat abgelehnt: Dieses Gerät ist nicht im Netzwerk des Hubs. Verbinden Sie sich mit demselben Netzwerk wie der Hub (kein VPN) und versuchen Sie es erneut.',
      alreadyClaimed: 'Dieser Hub hat bereits einen Besitzer. Bitten Sie ihn, Sie einzuladen.',
      invalidCloudToken: 'Ihre Torik-Konto-Sitzung wurde abgelehnt. Melden Sie sich erneut an und übernehmen Sie dann.',
      invalidDevice: 'Der Hub hat den Schlüssel dieses Geräts abgelehnt. Versuchen Sie es erneut.',
      cloudUnreachable:
        'Der Hub konnte die Torik-Cloud nicht erreichen und sich daher nicht registrieren. Prüfen Sie die Internetverbindung des Hubs und versuchen Sie es erneut.',
      hubIdentityUnavailable:
        'Der Hub kann seine eigene Identität noch nicht lesen. Warten Sie einen Moment und versuchen Sie es erneut.',
      registrationFailed:
        'Die Cloud hat die Registrierung des Hubs unter Ihrem Konto abgelehnt. Versuchen Sie es erneut oder kontaktieren Sie den Support.',
      unsupported: 'Dieser Hub unterstützt die Übernahme nicht (ältere Software).',
      unreachable:
        'Unter dieser Adresse hat nichts geantwortet. Prüfen Sie, ob der Hub eingeschaltet und in diesem Netzwerk ist.',
      unproven:
        'Das Gerät unter dieser Adresse konnte nicht beweisen, dass es dieser Hub ist. Es wurde nichts übernommen und Ihr Konto wurde nicht dorthin gesendet.',
      malformed: 'Der Hub hat ohne Übernahme geantwortet. Es wurde nichts geändert.',
      refused: 'Der Hub hat die Übernahme abgelehnt.',
      cardAction: 'Herrenloser Hub — übernehmen?',
      cardHint:
        '{hub} gehört noch niemandem. Beim Übernehmen wird er unter Ihrem Torik-Konto registriert und Sie werden sein Besitzer.',
      cardSignIn: 'Melden Sie sich bei Ihrem Torik-Konto an, um {hub} zu übernehmen.',
      badgeWaiting: 'Wartet auf Übernahme',
      localPageHint: '{hub} hat noch keinen Besitzer — finden Sie ihn über die Suche nach lokalen Servern.',
      localPageAction: 'Lokale Server suchen',
      addressLabel: 'Adresse',
      loopbackOnly:
        'Dieses Gerät erreicht den Hub nur unter {address} — auf seinem eigenen Rechner. Ein Hub nimmt eine Übernahme nie von sich selbst an (von dort kommen auch getunnelte Aufrufe), übernehmen Sie ihn also von einem anderen Gerät im selben Netzwerk.',
      tokenRetired:
        'Der Hub akzeptiert für die Übernahme keine Kontoanmeldung mehr — es ist eine Lizenz erforderlich. Aktualisieren Sie die App und versuchen Sie es erneut.',
      licenceUsed:
        'Diese Übernahmelizenz wurde bereits eingelöst. Es wurde nichts geändert — versuchen Sie es erneut, um eine neue zu erhalten.',
      licenceExpired: 'Die Übernahmelizenz ist abgelaufen, bevor der Hub sie nutzen konnte. Versuchen Sie es erneut.',
      licenceMismatch: 'Diese Lizenz wurde für einen anderen Hub ausgestellt. Es wurde nichts übernommen.',
      licenceInvalid:
        'Der Hub konnte die vom Cloud-Dienst signierte Lizenz nicht prüfen. Aktualisieren Sie App und Hub und versuchen Sie es erneut.',
      licenceRequired:
        'Der Hub erwartete eine Übernahmelizenz, es wurde jedoch keine gesendet. Aktualisieren Sie die App und versuchen Sie es erneut.',
      licenceRefused: 'Der Cloud-Dienst hat die Ausstellung einer Übernahmelizenz für diesen Hub abgelehnt.',
      licenceUnknownHub:
        'Der Cloud-Dienst konnte diesen Hub nicht identifizieren und hat daher keine Lizenz ausgestellt. Lassen Sie den Hub einmal das Internet erreichen und versuchen Sie es erneut.',
      licenceAlreadyOwned:
        'Ein anderes Torik-Konto besitzt diesen Hub bereits. Bitten Sie dessen Besitzer um eine Einladung.',
      licenceUnavailable:
        'Der Cloud-Dienst kann derzeit keine Übernahmelizenzen ausstellen. Versuchen Sie es später erneut oder wenden Sie sich an den Support.',
      licenceUnauthorized:
        'Ihre Torik-Kontositzung wurde abgelehnt. Melden Sie sich erneut an und übernehmen Sie dann.',
      licenceUnreachable:
        'Der Torik-Cloud-Dienst war nicht erreichbar, daher konnte keine Lizenz ausgestellt werden. Prüfen Sie die Internetverbindung dieses Geräts und versuchen Sie es erneut.',
      licenceMalformed:
        'Der Cloud-Dienst hat ohne Lizenz geantwortet. Es wurde nichts übernommen — versuchen Sie es erneut.',
      password: {
        title: 'Lokales Passwort festlegen',
        intro:
          'Ein Passwort für {hub} hält dieses Haus auch ohne Internet am Laufen — und lässt jeden im Haus anmelden, auch wenn der Torik-Cloud-Dienst nicht erreichbar ist.',
        label: 'Passwort',
        hint: 'Mindestens 8 Zeichen.',
        confirmLabel: 'Passwort bestätigen',
        mismatch: 'Die beiden Passwörter stimmen nicht überein.',
        currentLabel: 'Aktuelles Passwort',
        save: 'Passwort speichern',
        saving: 'Wird gespeichert…',
        skip: 'Jetzt nicht',
        done: 'Lokales Passwort gespeichert — dieses Haus funktioniert jetzt auch ohne Internet.',
        noSessionNote:
          'Dieses Gerät ist auf dem Hub nicht angemeldet, daher konnte kein lokales Passwort festgelegt werden. Öffnen Sie den Hub und legen Sie dort eines fest.',
        resolving: 'Dieser Server wird geprüft …',
        noAddress:
          'Dieser Server hat keine Adresse, die dieses Gerät anwählen kann — ein lokales Passwort lässt sich von hier nicht festlegen.',
        noAccount: 'Melden Sie sich bei Ihrem Torik-Konto an, um ein lokales Passwort auf diesem Hub festzulegen.',
        notThisAccount:
          'Dieser Hub gehört zu einem anderen Torik-Konto, daher kann dieses Konto sein lokales Passwort nicht festlegen.',
        noAnswer:
          'An der Adresse dieses Hubs hat niemand geantwortet, daher konnte kein lokales Passwort festgelegt werden. Prüfen Sie, ob der Hub eingeschaltet und in diesem Netzwerk ist.',
        close: 'Schließen',
        required: 'Geben Sie ein Passwort ein.',
        tooShort: 'Das Passwort ist zu kurz — mindestens 8 Zeichen.',
        tooLong: 'Das Passwort ist zu lang (höchstens 72 Bytes).',
        wrongCurrent: 'Das ist nicht das Passwort, das dieses Konto auf dem Hub bereits hat.',
        notPermitted: 'Nur ein Administrator kann dieses Passwort festlegen.',
        noSuchUser: 'Der Hub kennt dieses Konto nicht.',
        noSession: 'Dieses Gerät ist auf dem Hub nicht angemeldet und kann daher kein Passwort festlegen.',
        invalidCredentials: 'Falscher Benutzername oder falsches Passwort.',
        disabled: 'Dieses Konto ist auf diesem Hub deaktiviert.',
        outsideWindow:
          'Dieses Konto kann sich nur innerhalb der auf dem Hub eingestellten Zeiten anmelden. Bitten Sie den Besitzer des Hubs, das Zeitfenster zu verschieben.',
        tooManyAttempts: 'Zu viele Versuche. Warten Sie eine Minute und versuchen Sie es erneut.',
        unreachable:
          'Unter dieser Adresse hat niemand geantwortet. Prüfen Sie, ob der Hub eingeschaltet und in diesem Netzwerk ist.',
        refused: 'Der Hub hat das Festlegen des Passworts abgelehnt.',
      },
    },
    join: {
      title: 'Diesem Hub beitreten',
      intro:
        'Dieser Hub ist in Ihrem Netzwerk und Ihr Torik-Konto hat dort bereits eine Rolle. Beim Beitreten wird Ihr Konto hier verknüpft und dieses Gerät kann den Hub nutzen — ohne Code, ohne Passwort.',
      hubLabel: 'Hub',
      accountLabel: 'Konto',
      roleLabel: 'Ihre Rolle',
      roleReading: 'Wird geprüft …',
      roleUnknown: 'Noch nicht bekannt',
      noCode:
        'Nichts einzugeben — Ihr Konto ist die Berechtigung. Der Code auf dem Bildschirm des Hubs ist für Gäste, Handwerker und Panels ohne Tastatur.',
      noAccount: 'Nicht angemeldet',
      signInRequired: 'Melden Sie sich bei Ihrem Torik-Konto an, um diesem Hub beizutreten.',
      confirm: 'Diesem Hub beitreten',
      working: 'Wird beigetreten …',
      retry: 'Erneut versuchen',
      cancel: 'Abbrechen',
      doneTitle: 'Sie sind {hub} beigetreten',
      doneBody: '{account} ist jetzt mit diesem Hub verknüpft, und dieses Gerät kann ihn nutzen.',
      roleLine: 'Ihre Rolle auf diesem Hub ist {role}.',
      continue: 'Weiter',
      noMatchingUser:
        'Dieser Hub hat noch keinen Benutzer mit Ihrer E-Mail-Adresse. Bitten Sie den Besitzer des Hubs, diese Adresse einzuladen, und versuchen Sie es erneut.',
      notAMember:
        'Ihr Torik-Konto hat auf diesem Hub keine Rolle. Bitten Sie den Besitzer des Hubs, diese Adresse einzuladen.',
      userDisabled: 'Dieses Konto ist auf diesem Hub deaktiviert. Bitten Sie den Besitzer des Hubs, es zu aktivieren.',
      outsideLoginWindow:
        'Dieses Konto kann sich nur innerhalb der auf dem Hub eingestellten Zeiten anmelden. Bitten Sie den Besitzer des Hubs, das Zeitfenster zu verschieben.',
      invalidCloudToken:
        'Ihre Torik-Konto-Sitzung wurde abgelehnt. Melden Sie sich erneut an und versuchen Sie es noch einmal.',
      deviceInUse:
        'Dieses Gerät ist bereits unter einem anderen Konto registriert. Entfernen Sie es dort zuerst oder verwenden Sie ein anderes Gerät.',
      alreadyClaimed:
        'Dieser Hub hat dieses Gerät gerade übernommen — die Anfrage war bereits verbraucht. Öffnen Sie den Hub erneut.',
      expired: 'Die Anfrage ist abgelaufen, bevor der Hub sie übernehmen konnte. Versuchen Sie es erneut.',
      grantKeyMissing:
        'Die Torik-Cloud kann die Berechtigung für dieses Gerät gerade nicht signieren. Versuchen Sie es in einem Moment erneut.',
      unknownDevice: 'Der Hub kennt diese Registrierung nicht. Versuchen Sie es erneut.',
      notApproved:
        'Der Hub hat die Berechtigung für dieses Gerät noch nicht erfasst. Versuchen Sie es in einem Moment erneut.',
      invalidProof: 'Der Hub hat den Schlüssel dieses Geräts abgelehnt. Versuchen Sie es erneut.',
      rateLimited: 'Zu viele Versuche von diesem Gerät. Warten Sie eine Minute und versuchen Sie es erneut.',
      unreachable:
        'Unter dieser Adresse hat nichts geantwortet. Prüfen Sie, ob der Hub eingeschaltet und in diesem Netzwerk ist.',
      malformed: 'Der Hub hat geantwortet, ohne dieses Gerät zu binden. Es wurde nichts geändert.',
      refused: 'Der Hub hat die Anfrage abgelehnt. Es wurde nichts geändert.',
    },

    // Ein Hub, den diese App nicht öffnen kann (Karte `t_bfe0edc9`): der Satz, der sagt, wessen

    // Berechtigung fehlt und wo der eigene Weg hinein liegt (utils/hubOpenFallback.ts).

    open: {
      title: '{hub} konnte nicht geöffnet werden',

      dismiss: 'Schließen',

      openLocalPage: 'Lokale Server suchen',

      openServers: 'Server',

      needsCredential:
        'Die Seiten dieses Hubs brauchen eine Berechtigung, die dieses Gerät nicht hat. Es wurde nichts gesendet und nichts geändert.',

      // Ein Satz pro Art, wie ein Hub verschlossen bleibt (`HUB_OPEN_FAILURES`).

      failure: {
        no_credential:
          'Dieses Gerät hat noch keine Berechtigung für {hub}. Ihr Torik-Konto öffnet es von hier — ohne Code und ohne Passwort.',

        credential_refused:
          '{hub} hat die Berechtigung dieses Geräts nicht akzeptiert, deshalb wurde sie verworfen. Öffnen Sie es von hier mit Ihrem Torik-Konto — ein Code ist nicht nötig.',

        no_cloud_session: 'Melden Sie sich bei Ihrem Torik-Konto an, um {hub} zu öffnen.',

        no_lan_address: '{hub} hat keine Adresse gemeldet, die dieses Gerät ansprechen kann.',

        no_account_identity:
          'Ihr Torik-Konto kennt {hub} noch nicht. Übernehmen Sie es hier, oder bitten Sie seinen Besitzer, diese Adresse einzuladen.',

        unreachable:
          'Unter {address} hat nichts geantwortet. Prüfen Sie, ob {hub} eingeschaltet und in diesem Netzwerk ist.',
        permission_held:
          'Der Browser hält diese Anfrage zurück: Diese Website darf noch nicht auf Ihr lokales Netzwerk zugreifen. Erlauben Sie den Zugriff auf das lokale Netzwerk und versuchen Sie es erneut – oder öffnen Sie {hub} über die Cloud.',

        not_this_hub: 'Unter {address} hat etwas geantwortet, und es ist nicht {hub}.',

        not_proven:
          '{hub} hat unter {address} geantwortet und konnte nicht beweisen, dass es den Schlüssel hält, den Ihr Konto hinterlegt hat. Es wurde nichts gesendet.',

        cannot_prove: 'Das Gerät unter {address} konnte nicht gefragt werden, ob es {hub} ist.',

        refused:
          '{hub} hat die Anfrage Ihres Torik-Kontos abgelehnt — bitten Sie seinen Besitzer, diese Adresse einzuladen.',

        // Die eigene Ablehnung der **Cloud** (`services/cloudSessionRefusal.ts`,
        // Plan FLOOR-PLAN-AND-PLAN-EDITOR.md §3.2/D3): der Server ist lokal
        // beschränkt. Kein Fehler — sein Zustand, einmal gesagt.
        remote_access_not_licensed:
          'Dieser Server ist auf lokalen Zugriff beschränkt — er ist aus seinem eigenen Netzwerk erreichbar. Der Fernzugriff ist in einem kostenpflichtigen Server-Paket enthalten.',
      },
    },
    // Die **Einrichtung** (Plan `LOCAL-SERVER-ONBOARDING-JOURNEY.md` §3/C2–C3,
    // Entscheidungen des Eigentümers §7 Q1/Q2/Q4): was die Seite „Lokal“ für
    // einen Server öffnet, der diesem Konto gehört und dessen Tarif ihn in seinem
    // eigenen Netzwerk hält. Erst der Zustand, dann der ehrliche Satz zum
    // bezahlten Tarif, zuletzt das lokale Passwort (`hub.adopt.password.*` — der
    // Schritt, den sich beide Wege teilen). Hier wird nichts verkauft: keine
    // Preisliste, kein Kauf — den Tarif verwaltet das Konto.
    onboard: {
      title: 'Server einrichten',
      intro:
        'Dieser Server arbeitet in Ihrem eigenen Netzwerk. Hier stehen der Lizenzstatus und das Passwort, das ihn auch ohne Internet erreichbar hält.',
      licenceLabel: 'Lizenz',
      reading: 'Wird gelesen …',
      remoteTitle: 'Fernzugriff erfordert einen bezahlten Tarif',
      remoteBody:
        'Der Fernzugriff auf diesen Server ist Teil eines bezahlten Tarifs. Verwalten Sie den Tarif in Ihrem Torik-Konto.',
      accountLink: 'Tarif im Konto verwalten',
      accountHint: 'Öffnet Ihr Torik-Konto im Browser.',
      openButton: '{hub} einrichten',
      doneTitle: '{hub} ist eingerichtet',
      doneSkipped: 'Fertig. Das lokale Passwort können Sie jederzeit auf dieser Seite festlegen.',
      noAddress:
        'Dieser Server hat keine Adresse gemeldet, die dieses Gerät anwählen kann — das lokale Passwort lässt sich von hier aus nicht festlegen. Öffnen Sie ihn zuerst in Ihrer Serverliste.',
    },
  },
  // WLED integration — the two tabs read these (WLEDSegmentsTab.vue, WLEDSettingsTab.vue)
  wled: {
    tabs: {
      segmentsTitle: 'Segmente',
      segmentsSubtitle:
        'Jedes aktive WLED-Segment kann als Lichtgerät importiert werden (inklusive Effekte, Paletten und Presets).',
    },
    discover: 'Erkennen',
    discovering: 'Erkennen...',
    creating: 'Erstelle...',
    createDevices: 'Lichtgeräte erstellen',
    loading: 'Segmente werden geladen...',
    emptyTitle: 'Keine Segmente gefunden',
    emptyMessage:
      'Auf Erkennen drücken, um das Segment-Layout vom WLED-Board zu lesen. Geräte werden pro Segment erstellt — ein Standard-Board mit einem Streifen hat ein Segment, das alle LEDs abdeckt.',
    createHint: 'Ein Lichtgerät pro Segment erstellen (Standard: alle).',
    loadFailed: 'Segmente konnten nicht geladen werden',
    createFailed: 'Geräte konnten nicht erstellt werden',
    discoveryFailed: 'Erkennung fehlgeschlagen',
    alreadyImported: 'Bereits importierte Segmente wurden übersprungen. Neue Lichter erscheinen unter Räume / Geräte.',
    colName: 'Segment',
    colType: 'Typ',
    colColor: 'Farbe',
    colEffect: 'Effekt',
    colPalette: 'Palette',
    colStatus: 'Status',
    online: 'Online',
    offline: 'Offline',
    settings: {
      title: 'Einstellungen',
      subtitle: 'Verbindungseinstellungen für das WLED-Board. Eine Integration verwaltet ein Board.',
      connected: 'Verbunden',
      disconnected: 'Getrennt',
      noUrl: 'Keine Board-URL konfiguriert',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      reconnecting: 'Neuverbindung...',
      reconnect: 'Neu verbinden',
      boardTitle: 'Board',
      refresh: 'Aktualisieren',
      name: 'Name',
      version: 'Firmware',
      leds: 'LEDs',
      channels: 'Kanäle',
      url: 'Board-URL',
      scanning: 'Suche läuft...',
      findOnNetwork: 'Im Netzwerk suchen',
      urlHint: 'IP-Adresse oder Hostname des WLED-Boards — oder „Im Netzwerk suchen“ verwenden.',
      apiKey: 'API-Schlüssel',
      apiKeyPlaceholder: 'Optional',
      hide: 'Ausblenden',
      show: 'Anzeigen',
      apiKeyHint: 'Nur nötig, wenn die WLED-Sicherheit aktiviert ist.',
      pollInterval: 'Abfrageintervall (Sekunden)',
      pollHint: 'Ersatz-Aktualisierung, wenn der WebSocket nicht verfügbar ist.',
      testing: 'Test läuft...',
      test: 'Verbindung testen',
      saved: 'Einstellungen gespeichert.',
      saving: 'Speichere...',
      save: 'Einstellungen speichern',
      errorUpdate: 'Integration konnte nicht aktualisiert werden',
      errorReconnect: 'Neuverbindung fehlgeschlagen',
      errorConnection: 'Verbindung fehlgeschlagen',
      errorSave: 'Einstellungen konnten nicht gespeichert werden',
    },
  },
} as const;
